/* Spejder Sport light interactions.
   Wishlist: localStorage-backed heart toggles (page integration = Wishlist card). */
/* Inline video facade (article/page bodies). Every YouTube iframe in a .rte
   body becomes the same component as the recipe hero (poster + scrim + play +
   caption, sections/spejder-article.liquid): the YouTube thumbnail is the
   poster, and the caption is the iframe's `title` attribute — written by the
   migration script `import:video-titles` from YouTube's own title (e.g.
   "TURTIP: Vinter i lejren"), which is also the accessible name (WCAG 4.1.2).
   The real player only loads on play (youtube-nocookie, autoplay), so article
   pages stop paying for N iframes up front. Runs whether or not the base
   theme's `.rte__video-wrapper` has already wrapped the iframe. */
(function () {
  var YT_ID = /(?:youtube(?:-nocookie)?\.com\/(?:embed\/|watch\?v=|v\/)|youtu\.be\/)([\w-]{6,})/i;
  var PLAY_SVG = '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M2.875 16C2.875 19.481 4.25781 22.8194 6.71922 25.2808C9.18064 27.7422 12.519 29.125 16 29.125C19.481 29.125 22.8194 27.7422 25.2808 25.2808C27.7422 22.8194 29.125 19.481 29.125 16C29.125 12.519 27.7422 9.18064 25.2808 6.71922C22.8194 4.25781 19.481 2.875 16 2.875C12.519 2.875 9.18064 4.25781 6.71922 6.71922C4.25781 9.18064 2.875 12.519 2.875 16Z" fill="white" stroke="white" stroke-miterlimit="10"/><path d="M12.4258 20.7746V11.2246L20.7758 15.9996L12.4258 20.7746Z" fill="#094541" stroke="#094541" stroke-miterlimit="10"/></svg>';
  function lang() { return (document.documentElement.lang || 'da').split('-')[0]; }
  function build(iframe) {
    var m = (iframe.getAttribute('src') || '').match(YT_ID);
    if (!m) return null;
    var id = m[1];
    var title = (iframe.getAttribute('title') || '').trim();
    var wrap = document.createElement('div');
    wrap.className = 'spejder-article__hero-video spejder-article__hero-video--inline';
    wrap.setAttribute('data-inline-video', id);
    var media = document.createElement('div');
    media.className = 'spejder-article__hero-video-media';
    var img = document.createElement('img');
    img.alt = '';
    img.loading = 'lazy';
    img.decoding = 'async';
    img.width = 1280; img.height = 720;
    // maxres is 16:9 and sharp but missing on older uploads; hqdefault always
    // exists (4:3 with letterbox bars that object-fit: cover crops away).
    // A missing size is NOT an error event: YouTube answers 404 with a valid
    // 120x90 grey placeholder, which loads — so treat a 120px-wide load as
    // missing too and step down maxres → sd (640x480) → hq (client card
    // yaz3U5ee follow-up: 6 of 112 videos showed the placeholder 12x enlarged).
    var posters = ['maxresdefault', 'sddefault', 'hqdefault'];
    function nextPoster() {
      var name = posters.shift();
      if (!name) return;
      img.src = 'https://i.ytimg.com/vi/' + id + '/' + name + '.jpg';
    }
    img.addEventListener('load', function () { if (img.naturalWidth <= 120 && posters.length) nextPoster(); });
    img.addEventListener('error', nextPoster);
    nextPoster();
    media.appendChild(img);
    var scrim = document.createElement('div');
    scrim.className = 'spejder-article__hero-video-scrim';
    scrim.setAttribute('aria-hidden', 'true');
    media.appendChild(scrim);
    wrap.appendChild(media);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'spejder-article__hero-play';
    btn.setAttribute('aria-label', title ? 'Afspil video: ' + title : 'Afspil video');
    btn.innerHTML = PLAY_SVG;
    wrap.appendChild(btn);
    if (title) {
      var cap = document.createElement('p');
      cap.className = 'spejder-article__hero-caption';
      cap.textContent = title;
      wrap.appendChild(cap);
    }
    btn.addEventListener('click', function () {
      if (!wrap.querySelector('iframe')) {
        var f = document.createElement('iframe');
        f.className = 'spejder-article__hero-video-el';
        f.setAttribute('data-hero-video-el', '');
        f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&playsinline=1&cc_load_policy=1&hl=' + lang() + '&cc_lang_pref=' + lang();
        f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        f.setAttribute('allowfullscreen', '');
        f.title = title || 'YouTube video';
        wrap.appendChild(f);
        f.focus();
      }
      wrap.classList.add('is-playing');
    });
    return wrap;
  }
  function enhance(root) {
    (root || document).querySelectorAll('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="youtube-nocookie.com/embed"]').forEach(function (iframe) {
      if (iframe.closest('[data-inline-video]') || iframe.closest('[data-hero-video]')) return;
      var facade = build(iframe);
      if (!facade) return;
      var target = iframe.parentElement && iframe.parentElement.classList.contains('rte__video-wrapper') ? iframe.parentElement : iframe;
      target.replaceWith(facade);
    });
  }
  window.theme = window.theme || {};
  window.theme.enhanceInlineVideos = enhance;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { enhance(); });
  else enhance();
  document.addEventListener('shopify:section:load', function (e) { enhance(e.target); });
})();
/* a11y announcer (WCAG 4.1.3): writes to the shared polite live region in
   layout/theme.liquid. Clears first so an identical message is re-spoken. */
(function () {
  window.theme = window.theme || {};
  window.theme.announce = function (text) {
    var region = document.querySelector('[data-live-region]');
    if (!region) return;
    region.textContent = '';
    setTimeout(function () { region.textContent = text; }, 50);
  };
  /* Add-to-cart confirmation. Focus moves into the cart drawer, but a screen
     reader gets no spoken confirmation of what happened without this. */
  document.addEventListener('theme:product:add', function (e) {
    var title = '';
    try { title = (e.detail && e.detail.response && e.detail.response.product_title) || ''; } catch (err) {}
    window.theme.announce(title ? title + ' tilføjet til kurven' : 'Produkt tilføjet til kurven');
  });
})();
(function () {
  var KEY = 'spejder:wishlist';
  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function save(list) { localStorage.setItem(KEY, JSON.stringify(list)); }
  function sync() {
    var list = load();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var on = list.indexOf(btn.dataset.productHandle) !== -1;
      btn.classList.toggle('is-active', on);
      /* The PDP hearts declare aria-pressed; the card hearts don't. Keep
         whichever the markup opted into in step with the stored state. */
      if (btn.hasAttribute('aria-pressed')) btn.setAttribute('aria-pressed', String(on));
    });
  }
  /* Exposed so a subtree mounted after load can pick up stored state — the
     "Om produktet" overlay builds its heart client-side, long after the
     DOMContentLoaded sync (assets/spejder-pdp.js initWishlist). */
  window.theme = window.theme || {};
  window.theme.spejderWishlistSync = sync;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var list = load(), h = btn.dataset.productHandle, i = list.indexOf(h);
    if (i === -1) list.push(h); else list.splice(i, 1);
    save(list); sync();
  });
  document.addEventListener('DOMContentLoaded', sync);
  document.addEventListener('shopify:section:load', sync);
  sync();
})();

/* Cart drawer upsell buy controls: the custom "Vælg størrelse" listbox adds
   the picked size STRAIGHT to the cart (no second click — Emil 2026-08-21),
   the per-product button adds single-variant products — both via /cart/add.js
   + the theme's 'theme:cart:refresh' listener (re-fetches and re-renders the
   open drawer). Delegated so everything survives drawer re-renders. The
   listbox is custom markup (cart-upsell-card.liquid) because a native
   select's open list can't be styled to the design. */
(function () {
  function addUpsellVariant(id, control) {
    control.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { document.dispatchEvent(new CustomEvent('theme:cart:refresh')); })
      .catch(function () { control.disabled = false; });
  }
  function closeSizeLists(except) {
    document.querySelectorAll('[data-cart-upsell-sizes]').forEach(function (wrap) {
      if (wrap === except) return;
      var toggle = wrap.querySelector('[data-cart-upsell-size-toggle]');
      var list = wrap.querySelector('.cart-upsell__sizelist');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (list) list.hidden = true;
    });
  }
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cart-upsell-size-toggle]');
    if (toggle) {
      var wrap = toggle.closest('[data-cart-upsell-sizes]');
      var list = wrap.querySelector('.cart-upsell__sizelist');
      var willOpen = list.hidden;
      closeSizeLists(wrap);
      list.hidden = !willOpen;
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      return;
    }
    var opt = e.target.closest('[data-cart-upsell-size]');
    if (opt) {
      var optWrap = opt.closest('[data-cart-upsell-sizes]');
      var optToggle = optWrap.querySelector('[data-cart-upsell-size-toggle]');
      var optList = optWrap.querySelector('.cart-upsell__sizelist');
      optList.hidden = true;
      optToggle.setAttribute('aria-expanded', 'false');
      var label = optToggle.querySelector('span');
      if (label) label.textContent = opt.textContent.trim();
      addUpsellVariant(opt.getAttribute('data-variant-id'), optToggle);
      return;
    }
    if (!e.target.closest('[data-cart-upsell-sizes]')) closeSizeLists();
    var btn = e.target.closest('.cart-upsell__atc');
    if (!btn) return;
    e.preventDefault();
    var holder = btn.closest('[data-cart-upsell-buy]');
    var idInput = holder && holder.querySelector('input[name="id"]');
    if (!idInput || !idInput.value) return;
    addUpsellVariant(idInput.value, btn);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSizeLists();
  });
})();

/* "Fortsæt med at shoppe" must close the drawer (Emil 2026-08-21), and so
   must removing the LAST line item (Fjern — Emil 2026-08-21; the removal
   itself still runs through Broadcast's [data-item-remove] wiring, this only
   dismisses the overlay alongside it). Since 2026-09-15 (Magnus) Fjern on a
   cart with more lines keeps the drawer open: the line just disappears and
   the rest of the cart stays on screen — the drawer lists the whole cart, so
   the count of .cart__item rows is the live line count. theme.js binds
   [data-cart-drawer-close] at drawer init, but the foot re-renders via AJAX
   on every cart refresh, orphaning the button — so this delegated handler
   routes both through the X, whose wiring always works. The .drawer--cart
   guard keeps the cart PAGE's own Fjern links out of it. */
var drawerReopenGuard = null;
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-cart-drawer-close], [data-item-remove]');
  if (!btn) return;
  var drawer = btn.closest('.drawer--cart');
  if (!drawer) return;
  if (btn.matches('[data-item-remove]') && drawer.querySelectorAll('.cart__item').length > 1) return;
  var x = drawer.querySelector('.drawer__close');
  if (x && x !== btn) x.click();
  /* Fjern only: Broadcast RE-OPENS the drawer when the removal's cart
     refresh lands (~600ms later — the same auto-open as add-to-cart), and
     re-closing it mid-transition still flashed the slide-in (Emil
     2026-08-21). So the drawer is made INVISIBLE (.spejder-noflash) for the
     suppression window — the reopen can't paint at all — while a
     short-lived observer resets Broadcast's open state the moment is-open
     comes back. The veil lifts once that settles (or at the 3s timeout), so
     a genuine add-to-cart open afterwards behaves normally. */
  if (btn.matches('[data-item-remove]') && !drawerReopenGuard) {
    var until = Date.now() + 3000;
    drawer.classList.add('spejder-noflash');
    var disarm = function () {
      if (drawerReopenGuard) { drawerReopenGuard.disconnect(); drawerReopenGuard = null; }
      setTimeout(function () { drawer.classList.remove('spejder-noflash'); }, 400);
    };
    drawerReopenGuard = new MutationObserver(function () {
      if (Date.now() > until) { disarm(); return; }
      if (!drawer.classList.contains('is-open')) return;
      disarm();
      var x2 = drawer.querySelector('.drawer__close');
      if (x2) x2.click();
    });
    drawerReopenGuard.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    setTimeout(disarm, 3000);
  }
  /* CAPTURE phase: Broadcast's own [data-item-remove] handler stops the
     click's propagation, so a bubble listener at document never fires. */
}, true);

/* Generic mouse drag-to-scroll for every horizontal carousel (Emil
   2026-08-21) — the split-hero mechanics promoted sitewide: mouse-only
   (touch already pans natively), >4px counts as a drag, the click that
   follows a real drag is swallowed so card/chip links don't fire, and
   scroll-snap is suspended for the duration so positions track 1:1 —
   restoring it on release re-snaps like a native pan. One delegated
   implementation; the selector list is the registry of draggable rows. */
(function () {
  var ROWS = [
    '[data-grid-slider]',
    '.spejder-hero__track',
    '.spejder-minibanner__row',
    '.spejder-category-links__row',
    '.logos__slider',
    '.spejder-blog-posts__row',
    '.spejder-blog-nav__slider',
    '.cart-upsell__row',
    '.spejder-member-dashboard__products-row',
    '.spejder-expert__grid',
    '.spejder-pdp__slides',
    '.spejder-facet-chips',
    '.spejder-blog-header__chips',
    '.spejder-article__anchor-nav-list'
  ].join(',');
  var drag = null;
  var suppress = false;
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var el = e.target.closest && e.target.closest(ROWS);
    if (!el || el.scrollWidth <= el.clientWidth + 1) return;
    drag = { el: el, id: e.pointerId, x: e.clientX, left: el.scrollLeft, moved: false, snap: el.style.scrollSnapType };
  });
  document.addEventListener('pointermove', function (e) {
    if (!drag) return;
    var dx = e.clientX - drag.x;
    if (!drag.moved && Math.abs(dx) > 4) {
      drag.moved = true;
      /* Capture only once this is a REAL drag. Capturing on pointerdown
         retargets the compatibility mouse events to the row, so `click`
         fires on the row instead of whatever was pressed — every button
         and link inside a draggable row (quick add, card links, chips)
         went dead on mouse. A plain click now never captures; a drag
         still does, and its trailing click is swallowed by `suppress`. */
      try { drag.el.setPointerCapture(drag.id); } catch (err) {}
      drag.el.style.scrollSnapType = 'none';
      drag.el.classList.add('is-drag-scrolling');
    }
    if (drag.moved) drag.el.scrollLeft = drag.left - dx;
  });
  function endDrag() {
    if (!drag) return;
    var el = drag.el;
    var moved = drag.moved;
    var snap = drag.snap;
    drag = null;
    el.classList.remove('is-drag-scrolling');
    if (moved) {
      el.style.scrollSnapType = snap;
      suppress = true;
      setTimeout(function () { suppress = false; }, 0);
    }
  }
  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);
  document.addEventListener('click', function (e) {
    if (suppress) { e.preventDefault(); e.stopPropagation(); }
  }, true);
  document.addEventListener('dragstart', function (e) {
    if (drag) e.preventDefault();
  });
})();

/* The cart drawer's focus trap lands on the close X on open, and programmatic
   focus counts as :focus-visible — so the theme's focus ring paints the X the
   moment the overlay appears ("marked", Emil 2026-08-21). Retarget only that
   INITIAL trap focus (recognizable by the previous focus sitting OUTSIDE the
   drawer) onto the invisible drawer container; a keyboard user Tabbing to the
   X inside the drawer still gets the ring, and the trap keeps working. */
document.addEventListener('focusin', function (e) {
  if (!e.target.closest || !e.target.closest('.drawer--cart .drawer__close')) return;
  if (e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest('.drawer--cart')) return;
  var inner = e.target.closest('.drawer__inner');
  if (!inner) return;
  inner.setAttribute('tabindex', '-1');
  inner.style.outline = 'none';
  inner.focus({ preventScroll: true });
});

/* Cart drawer "Anbefalet til dig" arrows — document-level delegation so the
   handlers survive the drawer's AJAX re-renders. Arrows grey out (Figma) at
   the scroll extremes; state syncs on scroll (fires during smooth scrolling
   too) and when a row first appears. */
(function () {
  function syncArrows(row) {
    var up = row.closest('[data-cart-upsell]');
    if (!up) return;
    var prev = up.querySelector('[data-cart-upsell-prev]');
    var next = up.querySelector('[data-cart-upsell-next]');
    var max = row.scrollWidth - row.clientWidth - 1;
    if (prev) prev.classList.toggle('is-disabled', row.scrollLeft <= 0);
    if (next) next.classList.toggle('is-disabled', row.scrollLeft >= max);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-upsell-prev], [data-cart-upsell-next]');
    if (!btn) return;
    var row = btn.closest('[data-cart-upsell]').querySelector('[data-cart-upsell-row]');
    if (!row) return;
    var card = row.firstElementChild;
    var step = card ? card.getBoundingClientRect().width + 12 : 232;
    row.scrollBy({ left: btn.hasAttribute('data-cart-upsell-prev') ? -step : step, behavior: 'smooth' });
  });
  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-cart-upsell-row]')) syncArrows(e.target);
  }, true);
  /* At most once per frame (Trello "Load hastighed", 2026-10-05). The observer
     below sees EVERY DOM change on the page, and each sync reads scrollWidth —
     a forced layout. A category page makes hundreds of changes while it loads
     (Relewise grid swap, facets, cards), which cost ~300 ms of layout on a 4G
     phone profile. Coalescing to one sync per frame keeps the same behaviour. */
  var syncQueued = false;
  var syncAll = function () {
    if (syncQueued) return;
    syncQueued = true;
    requestAnimationFrame(function () {
      syncQueued = false;
      document.querySelectorAll('[data-cart-upsell-row]').forEach(syncArrows);
    });
  };
  new MutationObserver(syncAll).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', syncAll);

  /* Live recommendations: the theme's cart flows only swap line items +
     price, so on any cart mutation we re-fetch the drawer section and swap
     the [data-cart-upsell-outer] anchor — in-cart exclusions and metafield
     sources then always reflect the current cart. Debounced + race-guarded. */
  var refreshTimer = null;
  var refreshSeq = 0;
  function refreshUpsell() {
    var outer = document.querySelector('[data-cart-upsell-outer]');
    if (!outer) return;
    var seq = ++refreshSeq;
    /* full-page fetch, NOT ?section_id= — section renders resolve product_list
       settings only partially (empty drop items), which silently drops the
       whole upsell block from the output */
    fetch(window.location.pathname + window.location.search)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (seq !== refreshSeq) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-upsell-outer]');
        var cur = document.querySelector('[data-cart-upsell-outer]');
        if (!cur || !fresh) return;

        /* The seed for the API top-up lives in an ATTRIBUTE on the anchor, not
           in its innerHTML — so it has to be copied across explicitly. Missing
           this was why the row never recovered: a page loaded with an empty
           cart renders data-rec-product-id="", the swap below left that stale
           "" in place, and topUpRecs() then bailed on its !productId guard
           forever after. */
        cur.setAttribute('data-rec-product-id', fresh.getAttribute('data-rec-product-id') || '');
        cur.setAttribute('data-in-cart', fresh.getAttribute('data-in-cart') || '');

        /* Only commit the server's markup when it actually carries cards.
           rec_cards is built from theme.upsell metafields, which almost no
           product has, so on a normal add-to-cart `fresh` is an EMPTY row —
           committing it blanked a populated row, and `.cart-upsell:has(
           [data-cart-upsell-row]:empty)` (spejder.css) then hid the whole
           block. That is the "recommendations flash and vanish" QA report.
           With no server cards, keep what is on screen and just drop the ones
           now in the cart, so the exclusion contract still holds. */
        var freshRow = fresh.querySelector('[data-cart-upsell-row]');
        // Server-rendered placeholders don't count as cards: they must not
        // replace real cards already on screen.
        var freshCards = freshRow ? freshRow.querySelectorAll('.cart-upsell__card:not([data-cart-upsell-skeleton])').length : 0;
        if (freshCards) {
          cur.innerHTML = fresh.innerHTML;
        } else {
          var curRow = cur.querySelector('[data-cart-upsell-row]');
          if (!curRow) {
            cur.innerHTML = fresh.innerHTML;
          } else {
            /* Prune AFTER the top-up resolves, not before: the card being
               dropped is usually the one just added to the cart, and removing
               it up front emptied the row for the ~400ms the API call takes —
               a visible blank block, i.e. the same flash by another route.
               Holding the stale card until its replacements land means the row
               never dips to zero on screen. */
            var pruneInCart = function () {
              var inCart = (cur.getAttribute('data-in-cart') || '').split(',').filter(Boolean);
              if (!inCart.length) return;
              curRow.querySelectorAll('.cart-upsell__card[data-handle]').forEach(function (c) {
                if (inCart.indexOf(c.getAttribute('data-handle')) !== -1) c.remove();
              });
            };
            topUpRecs().then(pruneInCart);
            return;
          }
        }
        topUpRecs();
      })
      .catch(function () {});
  }

  /* Shopify-standard top-up: the metafield cards are merchant curation and stay
     first, but they are optional per product — with one curated product in the
     cart the row used to show a single card. Top the row up to REC_LIMIT from
     the Product Recommendations API (Search & Discovery), same pattern as the
     PDP: section-render spejder-cart-recs with intent=complementary, falling
     back to intent=related when no complementary products are configured.
     Dedupe against curated cards + earlier fetches via data-handle. */
  var REC_LIMIT = 8;
  var recSeq = 0;

  /* Relewise mode: whole-basket complements (PurchasedWithMultipleProducts,
     display location Cart/Basket) replace Shopify's single-product intents —
     cart lines become {productId: varenummer (SKU prefix), variantId: SKU}.
     Cards stay Shopify-rendered via the relewise-cart-card product view, so
     dedupe-by-handle keeps working. Resolves null when Relewise is off or
     fails → caller falls back to the Shopify path. */
  /* Relewise product id of a cart line = custom.relewise_id = the varenummer,
     i.e. the SKU before its first separator. Business Central writes SKUs as
     "<varenummer>_<variantnr>" (underscore); the pre-BC import used "-", still
     accepted. C2S/RETUR second-hand pieces have no varenummer — their whole SKU
     is the id. Mirrors schema:relewise-id in the migration repo; splitting on
     the dash alone sent the full variant SKU as product id (Relewise go-live
     check 2026-09-15), so Relewise never matched the product. */
  function relewiseProductId(sku) {
    if (/^c2s/i.test(sku)) return sku;
    var cut = sku.search(/[_-]/);
    return cut === -1 ? sku : sku.slice(0, cut);
  }

  function fetchRelewiseCards(need) {
    var cfg = window.spejder && window.spejder.relewise;
    if (!cfg || !cfg.enabled || !window.Relewise) return Promise.resolve(null);
    /* Consent-correct identity via the shared helper (assets/relewise-batch.js),
       which waits for the app embed's global instead of testing for it now.
       Asked for alongside the cart, not after it: the page's other rows queue
       their requests the moment the app hands out the user, and this one has
       to be ready by then to share their batch. */
    var userPromise = window.spejder.relewiseUser
      ? window.spejder.relewiseUser()
      : Promise.resolve(Relewise.UserFactory.anonymous());
    var handleKey = cfg.shop + '_ShopifyHandle';
    return Promise.all([fetch('/cart.js').then(function (r) { return r.json(); }), userPromise])
      .then(function (cartAndUser) {
        var cart = cartAndUser[0];
        var lines = (cart.items || []).filter(function (i) { return i.sku; }).map(function (i) {
          return { productId: relewiseProductId(i.sku), variantId: i.sku };
        });
        if (!lines.length) return null;
        var request = new Relewise.PurchasedWithMultipleProductsBuilder({
          language: cfg.language,
          currency: cfg.currency,
          displayedAtLocation: 'Cart/Basket',
          user: cartAndUser[1],
        })
          .addProducts(lines)
          .setNumberOfRecommendations(need)
          .filters(function (f) {
            f.addProductIdFilter(lines.map(function (l) { return l.productId; }), true);
          })
          .setSelectedProductProperties({ dataKeys: [handleKey] })
          .build();
        /* Sent in the page's shared batch (Relewise go-live check 2026-09-15:
           batch the rows that load together). Low priority: at page load the
           drawer is closed, so it must not take products from rows on screen. */
        var recommendation = window.spejder.relewiseBatch
          ? window.spejder.relewiseBatch.recommend(request, { priority: 'low' })
          : new Relewise.Recommender(cfg.datasetId, cfg.apiKey, { serverUrl: cfg.serverUrl })
              .recommendPurchasedWithMultipleProducts(request);
        return recommendation
          .then(function (result) {
            var handles = ((result && result.recommendations) || []).map(function (rec) {
              return rec.data && rec.data[handleKey] && rec.data[handleKey].value;
            }).filter(Boolean);
            if (!handles.length) return [];
            return Promise.all(handles.map(function (h) {
              return fetch('/products/' + h + '?view=relewise-cart-card')
                .then(function (r) { return r.ok ? r.text() : ''; })
                .catch(function () { return ''; });
            })).then(function (htmls) {
              var holder = document.createElement('div');
              holder.innerHTML = htmls.join('');
              return Array.prototype.slice.call(holder.querySelectorAll('.cart-upsell__card'));
            });
          });
      })
      .catch(function () { return null; });
  }

  /* Returns a promise that settles once any new cards have been appended, so
     callers can sequence follow-up DOM work (see refreshUpsell's prune) instead
     of racing it. Always resolves — never rejects. */
  /* Skeleton cards (Magnus 2026-09-10): the Relewise + card fetch takes up to
     a second, during which the row used to sit empty (or hide the block).
     Placeholders in the card's own frame hold the slots; they are removed the
     moment real cards land, or when nothing can be recommended. */
  var SKELETON_SEL = '[data-cart-upsell-skeleton]';
  function skeletonCard() {
    var el = document.createElement('div');
    el.className = 'cart-upsell__card cart-upsell__card--skeleton';
    el.setAttribute('data-cart-upsell-skeleton', '');
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<div class="spejder-skeleton__image"></div><div class="spejder-skeleton__line spejder-skeleton__line--title"></div><div class="spejder-skeleton__line spejder-skeleton__line--price"></div><div class="spejder-skeleton__button"></div>';
    return el;
  }
  function showSkeletons(row, count) {
    clearSkeletons(row);
    for (var i = 0; i < count; i++) row.appendChild(skeletonCard());
  }
  function clearSkeletons(row) {
    row.querySelectorAll(SKELETON_SEL).forEach(function (el) { el.remove(); });
  }

  function topUpRecs() {
    var outer = document.querySelector('[data-cart-upsell-outer]');
    if (!outer) return Promise.resolve();
    var productId = outer.getAttribute('data-rec-product-id');
    var row = outer.querySelector('[data-cart-upsell-row]');
    /* The Shopify path needs data-rec-product-id; the Relewise path reads the
       cart itself, so it must not be gated on that attribute (it's empty when
       the page loaded with an empty cart). */
    var relewiseOn = window.spejder && window.spejder.relewise && window.spejder.relewise.enabled;
    if (!row || (!productId && !relewiseOn)) return Promise.resolve();
    var have = row.querySelectorAll('.cart-upsell__card:not([data-cart-upsell-skeleton])').length;
    if (have >= REC_LIMIT) { clearSkeletons(row); return Promise.resolve(); }
    /* Two visible slots is what the drawer shows at once; more placeholders
       would only scroll. */
    showSkeletons(row, Math.min(2, REC_LIMIT - have));
    var base = (window.theme && theme.routes && theme.routes.product_recommendations_url) || '/recommendations/products';
    var seq = ++recSeq;
    var fetchIntent = function (intent) {
      return fetch(base + '?section_id=spejder-cart-recs&product_id=' + productId + '&limit=' + REC_LIMIT + '&intent=' + intent)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (seq !== recSeq) return [];
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return Array.prototype.slice.call(doc.querySelectorAll('[data-rec-cards] .cart-upsell__card'));
        })
        .catch(function () { return []; });
    };
    return fetchRelewiseCards(REC_LIMIT - have).then(function (relewiseCards) {
      if (relewiseCards && relewiseCards.length) return relewiseCards;
      if (!productId) return []; // Shopify fallback needs a seed product
      return fetchIntent('complementary').then(function (cards) {
        if (cards.length) return cards;
        return fetchIntent('related');
      });
    }).then(function (cards) {
      if (seq !== recSeq) return;
      clearSkeletons(row);
      if (!cards || !cards.length) return;
      var seen = {};
      row.querySelectorAll('.cart-upsell__card[data-handle]').forEach(function (c) { seen[c.getAttribute('data-handle')] = true; });
      cards.forEach(function (card) {
        var h = card.getAttribute('data-handle');
        if (!h || seen[h]) return;
        if (row.querySelectorAll('.cart-upsell__card').length >= REC_LIMIT) return;
        seen[h] = true;
        row.appendChild(card);
      });
    }).catch(function () { if (seq === recSeq) clearSkeletons(row); });
  }

  ['theme:cart:change', 'theme:cart:refresh'].forEach(function (ev) {
    document.addEventListener(ev, function () {
      /* Instantly, before the debounce and the section re-fetch: a row with
         no real cards gets its placeholders now, so the block is visible with
         a skeleton the moment the drawer opens on an add-to-cart. */
      var row = document.querySelector('[data-cart-upsell-row]');
      if (row && !row.querySelector('.cart-upsell__card:not([data-cart-upsell-skeleton])')) showSkeletons(row, 2);
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(refreshUpsell, 350);
    });
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', topUpRecs);
  } else {
    topUpRecs();
  }
})();

/* Featured products (tab collections): round header arrows scroll the active slider,
   and the "se alle" link follows the active tab. The same head pair is the only
   control on every breakpoint (client card MIxNNHXR, 2026-10-06); the slider's
   floating edge arrows are hidden in spejder.css. */
(function () {
  /* Desktop pages a full "page" per click — as many whole cards as the row shows
     (Figma), the paging the floating edge arrows had before the pair moved to
     the head. Round DOWN going back (the last item at/before scrollLeft - width):
     rounding up under-pages and can never reach 0 again. Going forward, the
     first item not fully visible at the right edge becomes the new left. */
  function page(slider, dir) {
    var items = slider.querySelectorAll('[data-grid-item]');
    if (!items.length) return;
    var target = null;
    if (dir < 0) {
      var desired = slider.scrollLeft - slider.clientWidth;
      target = items[0];
      for (var i = items.length - 1; i >= 0; i--) {
        if (items[i].offsetLeft <= desired + 1) { target = items[i]; break; }
      }
    } else {
      for (var j = 0; j < items.length; j++) {
        if (items[j].offsetLeft + items[j].clientWidth > slider.scrollLeft + slider.clientWidth + 1) { target = items[j]; break; }
      }
    }
    if (target) slider.scrollTo({ top: 0, left: Math.max(0, target.offsetLeft), behavior: 'smooth' });
  }
  function step(section, dir) {
    var slider = section.querySelector('.tab-content.current .grid--slider, .tab-content.current .grid--mobile-slider') ||
                 section.querySelector('.grid--slider, .grid--mobile-slider');
    if (!slider) return;
    if (window.matchMedia('(min-width: 750px)').matches) { page(slider, dir); return; }
    var item = slider.querySelector('.grid-item');
    var gap = parseFloat(getComputedStyle(slider).getPropertyValue('--gap')) || 20;
    var width = item ? item.getBoundingClientRect().width + gap : 340;
    slider.scrollBy({ left: dir * width, behavior: 'smooth' });
  }
  function syncArrows(section) {
    var slider = section.querySelector('.tab-content.current .grid--slider, .tab-content.current .grid--mobile-slider') ||
                 section.querySelector('.grid--slider, .grid--mobile-slider');
    var prevs = section.querySelectorAll('[data-spejder-slider-prev]');
    var nexts = section.querySelectorAll('[data-spejder-slider-next]');
    if (!slider || !prevs.length || !nexts.length) return;
    var max = slider.scrollWidth - slider.clientWidth - 1;
    prevs.forEach(function (b) { b.classList.toggle('is-disabled', slider.scrollLeft <= 0); });
    nexts.forEach(function (b) { b.classList.toggle('is-disabled', slider.scrollLeft >= max); });
    // Desktop shows the pair only while the active row can scroll.
    section.querySelectorAll('.spejder-slider-controls__arrows').forEach(function (a) {
      a.classList.toggle('is-overflowing', slider.scrollWidth > slider.clientWidth + 1);
    });
  }
  function syncAll() {
    document.querySelectorAll('.index-tab-collections').forEach(syncArrows);
  }
  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-spejder-slider-prev]');
    var next = e.target.closest('[data-spejder-slider-next]');
    if (prev || next) {
      step((prev || next).closest('.index-tab-collections'), prev ? -1 : 1);
      return;
    }
    var tab = e.target.closest('.index-tab-collections .tab-link');
    if (tab) {
      var section = tab.closest('.index-tab-collections');
      var idx = tab.getAttribute('data-tab');
      section.querySelectorAll('.spejder-seeall').forEach(function (a) {
        a.classList.toggle('current', a.getAttribute('data-tab-link') === idx);
      });
      setTimeout(function () { syncArrows(section); }, 50);
    }
  });
  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.classList && (e.target.classList.contains('grid--slider') || e.target.classList.contains('grid--mobile-slider'))) {
      var section = e.target.closest('.index-tab-collections');
      if (section) syncArrows(section);
    }
  }, true);
  document.addEventListener('DOMContentLoaded', syncAll);
  document.addEventListener('shopify:section:load', syncAll);
  window.addEventListener('load', syncAll);
  // Overflow is width-dependent (is-overflowing above).
  window.addEventListener('resize', syncAll);
})();

/* Featured blog posts: floating hover arrows scroll the article slider. */
(function () {
  function slider(btn) { return btn.closest('.spejder-blog-posts__outer').querySelector('[data-spejder-blog-slider]'); }
  function sync(outer) {
    var s = outer.querySelector('[data-spejder-blog-slider]');
    var prev = outer.querySelector('[data-spejder-blog-prev]');
    var next = outer.querySelector('[data-spejder-blog-next]');
    if (!s || !prev || !next) return;
    /* Nothing to scroll (the 4-up desktop row exactly fills its track) -> BOTH
       arrows stay disabled. Sub-pixel layout rounding can leave scrollWidth a
       hair over clientWidth, so require a real card-sized overflow. */
    var overflow = s.scrollWidth - s.clientWidth;
    var scrollable = overflow > 2;
    var max = overflow - 1;
    setState(prev, !scrollable || s.scrollLeft <= 0);
    setState(next, !scrollable || s.scrollLeft >= max);
  }
  function setState(btn, disabled) {
    btn.classList.toggle('is-disabled', disabled);
    btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
  }
  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-spejder-blog-prev]');
    var next = e.target.closest('[data-spejder-blog-next]');
    if (!prev && !next) return;
    var s = slider(prev || next);
    var card = s.querySelector('.spejder-blog-posts__card');
    var w = card ? card.getBoundingClientRect().width + 20 : 355;
    s.scrollBy({ left: (prev ? -1 : 1) * w, behavior: 'smooth' });
  });
  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-spejder-blog-slider')) {
      sync(e.target.closest('.spejder-blog-posts__outer'));
    }
  }, true);
  function syncAll() { document.querySelectorAll('.spejder-blog-posts__outer').forEach(sync); }
  document.addEventListener('DOMContentLoaded', syncAll);
  window.addEventListener('load', syncAll);
  /* Overflow is width-dependent: without these the disabled state goes stale
     the moment the viewport changes (or the theme editor re-renders the
     section), which is what made the arrow appear with nothing to scroll.
     Every other slider in this file already syncs on resize. */
  window.addEventListener('resize', syncAll);
  document.addEventListener('shopify:section:load', syncAll);
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(syncAll);
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[data-spejder-blog-slider]').forEach(function (el) { ro.observe(el); });
    });
  }
})();

/* Blog category: pill sub-nav slider. The right arrow only appears when the
   chips actually overflow (desktop); mobile relies on native touch scroll. */
(function () {
  function sync(navEl) {
    var s = navEl.querySelector('[data-spejder-blog-nav-slider]');
    var next = navEl.querySelector('[data-spejder-blog-nav-next]');
    if (!s || !next) return;
    var overflow = s.scrollWidth > s.clientWidth + 1;
    navEl.classList.toggle('has-overflow', overflow);
    var max = s.scrollWidth - s.clientWidth - 1;
    next.classList.toggle('is-disabled', s.scrollLeft >= max);
  }
  document.addEventListener('click', function (e) {
    var next = e.target.closest('[data-spejder-blog-nav-next]');
    if (!next) return;
    var navEl = next.closest('[data-spejder-blog-nav]');
    var s = navEl && navEl.querySelector('[data-spejder-blog-nav-slider]');
    if (!s) return;
    s.scrollBy({ left: s.clientWidth * 0.8, behavior: 'smooth' });
  });
  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-spejder-blog-nav-slider')) {
      sync(e.target.closest('[data-spejder-blog-nav]'));
    }
  }, true);
  function syncAll() { document.querySelectorAll('[data-spejder-blog-nav]').forEach(sync); }
  document.addEventListener('DOMContentLoaded', syncAll);
  window.addEventListener('load', syncAll);
  window.addEventListener('resize', syncAll);
})();

/* Shared heading-row prev/next pair (card Iktdw0TF). One handler for every
   "arrow pair beside a heading that scrolls a [data-grid-slider] row" consumer:
   the article product sliders (snippets/spejder-product-slider.liquid), both
   PDP recommendation rows (sections/related.liquid), the Relewise row
   (sections/spejder-recommendations.liquid), the PDP expert row
   (sections/spejder-expert.liquid) and the featured-collection row
   (sections/section-collection.liquid).

   It started mobile-only, with desktop left to the shared <grid-slider
   align-arrows> component's floating edge arrows. Those centre on the image
   10px inside the row edge — exactly where the edge card's own image arrows
   sit — so the two stacked (client cards QynPncvy, MIxNNHXR). Since
   2026-10-06 this pair is the control on desktop too, shown only while the row
   overflows (-overflow below), and CSS hides the floating pair. Drag/wheel
   scroll still come from <grid-slider> (§0.15d: reuse, don't fork).

   The contract is declared in markup, so a new consumer needs no JS:
     [data-spejder-arrows="<ancestor selector>"] on the controls wrapper, holding
       [data-spejder-arrow-prev] and [data-spejder-arrow-next]. The named ancestor
       is the scope that also contains the [data-grid-slider] row to scroll.
     [data-spejder-arrows-async] — opt-in for rows populated AFTER first paint
       (the PDP recommendations fetch, recently-viewed localStorage). The pair
       stays hidden via `is-ready` until the row actually holds cards, and a
       MutationObserver re-syncs on injection. Server-rendered rows omit it.
     [data-spejder-arrows-overflow] — opt-in `is-overflowing` class while the row
       is wider than its viewport, so CSS can hide a pair with nothing to page.

   NOTE: the tab-collections and blog-post handlers above are a different shape
   (tab switching / their own hover-reveal edge arrows) and keep their own
   `data-spejder-slider-*` and `data-spejder-blog-*` attributes — deliberately
   NOT the `data-spejder-arrow-*` pair this handler delegates on, so the two
   never both fire on one click. */
(function () {
  var ARROWS = '[data-spejder-arrows]';

  function scopeOf(arrows) { return arrows.closest(arrows.getAttribute('data-spejder-arrows')); }
  function scrollerOf(arrows) {
    var scope = scopeOf(arrows);
    return scope && scope.querySelector('[data-grid-slider]');
  }

  function setState(btn, off) {
    if (!btn) return;
    btn.classList.toggle('is-disabled', off);
    btn.setAttribute('aria-disabled', off ? 'true' : 'false');
  }

  function sync(arrows) {
    var s = scrollerOf(arrows);
    if (arrows.hasAttribute('data-spejder-arrows-async')) {
      arrows.classList.toggle('is-ready', !!s && s.querySelectorAll('[data-grid-item]').length > 0);
    }
    if (arrows.hasAttribute('data-spejder-arrows-overflow')) {
      arrows.classList.toggle('is-overflowing', !!s && s.scrollWidth > s.clientWidth + 1);
    }
    if (!s) return;
    var max = s.scrollWidth - s.clientWidth - 1;
    setState(arrows.querySelector('[data-spejder-arrow-prev]'), s.scrollLeft <= 0);
    setState(arrows.querySelector('[data-spejder-arrow-next]'), s.scrollLeft >= max);
  }

  function syncAll() { document.querySelectorAll(ARROWS).forEach(sync); }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-spejder-arrow-prev], [data-spejder-arrow-next]');
    if (!btn) return;
    // .is-disabled only sets pointer-events:none, which stops the mouse but not
    // Enter/Space on a focused button — hence the explicit guard.
    if (btn.classList.contains('is-disabled')) return;
    var s = scrollerOf(btn.closest(ARROWS));
    var card = s && s.querySelector('[data-grid-item]');
    if (!card) return;
    var gap = parseFloat(getComputedStyle(s).getPropertyValue('--gap')) || 12;
    var w = card.getBoundingClientRect().width + gap;
    var max = s.scrollWidth - s.clientWidth;
    var target = s.scrollLeft + (btn.hasAttribute('data-spejder-arrow-prev') ? -w : w);
    // Never leave a sliver for one more click: a row a few px narrower than
    // its cards would otherwise end on a 3px step. Less than half a card to
    // go -> this click goes all the way to that end.
    if (max - target < w / 2) target = max;
    if (target < w / 2) target = 0;
    s.scrollTo({ left: target, behavior: 'smooth' });
  });

  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || !t.hasAttribute || !t.hasAttribute('data-grid-slider')) return;
    document.querySelectorAll(ARROWS).forEach(function (a) {
      if (scrollerOf(a) === t) sync(a);
    });
  }, true);

  function init() {
    document.querySelectorAll(ARROWS).forEach(function (arrows) {
      if (arrows.hasAttribute('data-spejder-arrows-async') && !arrows.dataset.spejderArrowsObserved) {
        arrows.dataset.spejderArrowsObserved = 'true';
        // childList only: sync mutates classes/attributes, so it cannot re-enter.
        // rAF lets the injected cards lay out before they are measured.
        new MutationObserver(function () {
          requestAnimationFrame(function () { sync(arrows); });
        }).observe(scopeOf(arrows), { childList: true, subtree: true });
      }
      sync(arrows);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('load', init);
  window.addEventListener('resize', syncAll);
})();

/* Endless product row: [data-spejder-loop] on a [data-grid-slider] row
   (Image with product, client card pRmlud7C; Magnus 2026-10-30: after the
   last product the first one follows). While the real cards overflow, whole
   copies of the set sit before and after them and the row rests on the real
   set: once scrolling settles past either end it re-seats on the twin
   position one set away with an instant scroll, pixel-identical. Same
   re-seat as the PDP gallery loop (spejder-pdp.js initGallery), but this row
   shows several cards at once, so a view like 7, 8, 1 mixes real cards and
   copies, and the copies must work:
   - cloneNode keeps the cards' custom elements (quick add, swatch tooltips,
     siblings) and the hearts sync by handle;
   - ids get a suffix and form/for/aria references follow, so a copy's size
     chips use its own form (form="" resolves to the FIRST such id in the page);
   - the reveal animation is marked done, so copies never fade in mid-scroll;
   - grid-slider's mouse drag snaps to the first .is-visible card, so copies
     drop the class they were cloned with and the slider restarts to track them.
   Copies are aria-hidden with their controls out of the tab order, so screen
   readers and keyboards meet each product once. */
(function () {
  var ROW = '[data-spejder-loop]';
  var COPY = 'data-spejder-loop-copy';
  var REFS = ['form', 'for', 'aria-labelledby', 'aria-describedby', 'aria-controls'];
  var FOCUSABLE = 'a[href], button, input, select, textarea, summary, [tabindex]';

  function realCards(row) {
    return Array.prototype.filter.call(row.children, function (el) {
      return el.hasAttribute('data-grid-item') && !el.hasAttribute(COPY);
    });
  }

  function makeCopy(card, tag) {
    var copy = card.cloneNode(true);
    var ids = {};
    copy.setAttribute(COPY, '');
    copy.setAttribute('aria-hidden', 'true');
    copy.classList.remove('is-visible');
    // getAttribute, not .id: a product form's <input name="id"> shadows form.id.
    [copy].concat(Array.prototype.slice.call(copy.querySelectorAll('[id]'))).forEach(function (el) {
      var id = el.getAttribute('id');
      if (!id) return;
      ids[id] = id + '--' + tag;
      el.setAttribute('id', ids[id]);
    });
    copy.querySelectorAll('[' + REFS.join('], [') + ']').forEach(function (el) {
      REFS.forEach(function (name) {
        var value = el.getAttribute(name);
        if (value) el.setAttribute(name, value.split(/\s+/).map(function (id) { return ids[id] || id; }).join(' '));
      });
    });
    copy.querySelectorAll(FOCUSABLE).forEach(function (el) { el.setAttribute('tabindex', '-1'); });
    copy.querySelectorAll('[data-aos]').forEach(function (el) { el.classList.add('aos-animate'); });
    return copy;
  }

  // Sub-pixel positions: cards are a fraction of the row wide.
  function left(el) { return el.getBoundingClientRect().left; }

  function restartSlider(row) {
    var slider = row.closest('grid-slider');
    if (!slider || !slider.isInitialized || typeof slider.destroy !== 'function') return;
    slider.destroy();
    slider.dispatchEvent(new CustomEvent('theme:grid-slider:init'));
  }

  function setUp(row) {
    var cards = realCards(row);
    var looped = !!row._spejderLoop;
    var index = 0;
    // Keep the real card that starts the view (after a resize, too).
    if (cards.length > 1) {
      var step = left(cards[1]) - left(cards[0]);
      var home = left(cards[0]) - left(row.firstElementChild);
      if (step > 0) index = ((Math.round((row.scrollLeft - home) / step) % cards.length) + cards.length) % cards.length;
    }
    row.querySelectorAll(':scope > [' + COPY + ']').forEach(function (el) { el.remove(); });
    row._spejderLoop = null;
    if (cards.length < 2 || row.scrollWidth <= row.clientWidth + 1 || left(cards[1]) - left(cards[0]) <= 0) {
      if (looped) restartSlider(row);
      return;
    }

    var setWidth = (left(cards[1]) - left(cards[0])) * cards.length;
    // Enough copies on each side for a long swipe: two row widths at least.
    var sets = Math.max(1, Math.ceil((row.clientWidth * 2) / setWidth));
    var first = cards[0];
    var firstAfter = null;
    for (var s = 1; s <= sets; s++) {
      cards.forEach(function (card) {
        row.insertBefore(makeCopy(card, 'loop-b' + s), first);
        var copy = makeCopy(card, 'loop-a' + s);
        row.appendChild(copy);
        if (!firstAfter) firstAfter = copy;
      });
    }
    var st = row._spejderLoop = {
      count: cards.length,
      step: left(cards[1]) - left(cards[0]),
      home: left(first) - left(row.firstElementChild),
      set: left(firstAfter) - left(first),
      width: row.clientWidth,
    };
    row.scrollLeft = st.home + index * st.step;
    restartSlider(row);
  }

  // Back onto the real set: the twin position one set away looks the same.
  function reseat(row) {
    var st = row._spejderLoop;
    if (!st) return;
    var offset = row.scrollLeft - st.home;
    var half = st.step / 2;
    if (offset >= -half && offset < st.set - half) return;
    while (offset < -half) offset += st.set;
    while (offset >= st.set - half) offset -= st.set;
    row.scrollLeft = st.home + offset;
  }

  function settleSoon(row) {
    clearTimeout(row._spejderLoopTimer);
    row._spejderLoopTimer = setTimeout(function () {
      if (!row._spejderLoopHeld) reseat(row);
    }, 120);
  }

  document.addEventListener('scroll', function (e) {
    if (e.target && e.target._spejderLoop) settleSoon(e.target);
  }, true);

  // A finger, or grid-slider's mouse drag, still on the row: re-seating under
  // it would fight the gesture. Held like the PDP gallery loop.
  function hold(e) {
    var row = e.target.closest && e.target.closest(ROW);
    if (row && row._spejderLoop) row._spejderLoopHeld = true;
  }
  function release() {
    document.querySelectorAll(ROW).forEach(function (row) {
      if (!row._spejderLoopHeld) return;
      row._spejderLoopHeld = false;
      settleSoon(row);
    });
  }
  document.addEventListener('touchstart', hold, { passive: true, capture: true });
  document.addEventListener('mousedown', hold, true);
  window.addEventListener('touchend', release, { passive: true, capture: true });
  window.addEventListener('touchcancel', release, { passive: true, capture: true });
  window.addEventListener('mouseup', release, true);
  window.addEventListener('blur', release);

  // Capture phase: an arrow click pages from the real set, before the shared
  // [data-spejder-arrows] handler above computes its target.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-spejder-arrow-prev], [data-spejder-arrow-next]');
    var arrows = btn && btn.closest('[data-spejder-arrows]');
    var scope = arrows && arrows.closest(arrows.getAttribute('data-spejder-arrows'));
    var row = scope && scope.querySelector(ROW);
    if (row) reseat(row);
  }, true);

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document.querySelectorAll(ROW).forEach(function (row) {
        if (row._spejderLoop && row._spejderLoop.width === row.clientWidth) return;
        setUp(row);
      });
    }, 200);
  });

  function init() {
    document.querySelectorAll(ROW).forEach(function (row) {
      if (!row._spejderLoop) setUp(row);
    });
  }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('load', init);
})();

/* PLP Collection Header sub-nav (dynamic product-type circles): each 33px
   round button only appears when the row can actually scroll THAT direction
   (prev once scrolled off zero, next while content remains) and scrolls one
   viewport-width of tiles at a time — same overflow-gated pattern as the blog
   category pill slider above; hover-reveal itself is CSS-only (spejder.css),
   mirroring the shared <grid-slider> component's own hover idiom. */
(function () {
  function sync(section) {
    var row = section.querySelector('[data-category-row]');
    var prev = section.querySelector('[data-category-links-prev]');
    var next = section.querySelector('[data-category-links-next]');
    if (!row || !prev || !next) return;
    var overflow = row.scrollWidth > row.clientWidth + 1;
    var max = row.scrollWidth - row.clientWidth - 1;
    prev.classList.toggle('is-visible', overflow && row.scrollLeft > 0);
    next.classList.toggle('is-visible', overflow && row.scrollLeft < max);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-category-links-prev], [data-category-links-next]');
    if (!btn) return;
    var section = btn.closest('.spejder-category-links');
    var row = section && section.querySelector('[data-category-row]');
    if (!row) return;
    var dir = btn.hasAttribute('data-category-links-prev') ? -1 : 1;
    row.scrollBy({ left: dir * row.clientWidth * 0.8, behavior: 'smooth' });
  });
  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-category-row')) {
      var section = e.target.closest('.spejder-category-links');
      if (section) sync(section);
    }
  }, true);
  function syncAll() { document.querySelectorAll('.spejder-category-links--product-types').forEach(sync); }
  document.addEventListener('DOMContentLoaded', syncAll);
  window.addEventListener('load', syncAll);
  window.addEventListener('resize', syncAll);
})();

/* Member signup DRAWER (Figma 4623:35620): any a[href="#member-signup-drawer"]
   opens the singleton drawer rendered from theme.liquid — same hidden
   [data-popup-open] proxy convention as every spejder overlay. Since
   2026-09-08 this is THE membership signup: every "Opret dig" (cart drawer,
   cart page, PDP member row, price teasers) and "Bliv medlem" CTA lands here.
   The host remembers where the click came from ('cart' = cart drawer / cart
   page, 'page' otherwise): member-join.js reloads after a signup and re-opens
   the cart for 'cart', so the visitor lands back on the cart they were
   looking at, now at member prices. */
(function () {
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var trigger = e.target.closest('a[href="#member-signup-drawer"]');
    if (!trigger) return;
    e.preventDefault();
    var host = document.querySelector('[data-member-signup-drawer-host]');
    var proxy = host && host.querySelector('[data-popup-open]');
    if (!proxy) return;
    var cartDrawer = trigger.closest('cart-drawer');
    var fromCart = !!cartDrawer || document.body.classList.contains('template-cart');
    host.setAttribute('data-member-signup-origin', fromCart ? 'cart' : 'page');
    // One overlay at a time: the signup drawer renders below the open cart
    // drawer (it is a non-top-layer dialog), so the cart drawer closes first.
    // The post-signup reload brings it back (member_joined=cart).
    if (cartDrawer && typeof cartDrawer.closeCartDrawer === 'function') cartDrawer.closeCartDrawer();
    proxy.click();
  });
})();

/* PLP quick facet chips (Figma 4846:22156 / 4846:50083). Every chip —
   including Pris — opens its own dropdown; NOTHING opens the filter drawer
   from a chip (Emil 2026-08-17). Value links carry Shopify's
   url_to_add/url_to_remove and the Pris form carries hidden inputs, so other
   active filters and sort survive every apply.

   Chip ([data-facet-popout-toggle], aria-controls) and panel
   ([data-facet-panel], id) are SEPARATE subtrees: the chips strip is a
   horizontal overflow scroller, and iOS Safari pins fixed/absolute
   descendants of an overflow scroller to it — a panel inside the strip was
   clipped to the 36px chip row, so on iPhone every chip looked dead (client
   card "Mobil: Problemer med filter", 2026-08-25). The panels live in
   [data-facet-panels], a zero-height absolute layer at the sticky nav's
   top-left, and are positioned from the chip's box relative to that layer —
   they ride along with the sticky nav, so no scroll-close is needed.

   Applying a value used to NAVIGATE (the option is a plain <a href>), so the
   page reloaded and the dropdown the shopper was working in closed
   (Magnus 2026-09-08). Every apply — option link, active pill, "Ryd alle",
   the Pris form — now goes through the theme's own collection-filters-form
   AJAX path (pushState + grid/drawer re-render), the toolbar sync below
   re-renders chips + panels from the new URL, and the dropdown that was open
   is re-opened on its fresh panel. The href stays on the link, so a page
   without the filter element (or a failed fetch) still navigates. */
(function () {
  function panelFor(toggle) {
    var id = toggle.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }
  function syncNav() {
    // z-index lift for the nav while a panel is open (CSS also has a :has()
    // rule; the class covers browsers without :has()).
    document.querySelectorAll('.collection__nav').forEach(function (nav) {
      nav.classList.toggle('is-facet-open', !!nav.querySelector('[data-facet-panel]:not([hidden])'));
    });
  }
  function closeAll(except) {
    document.querySelectorAll('[data-facet-popout-toggle]').forEach(function (t) {
      if (t === except) return;
      var panel = panelFor(t);
      t.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
    });
    syncNav();
  }
  /* Open ONE chip's panel, positioned under the chip (relative to the panels
     layer). Also used by the toolbar sync to re-open the dropdown that was
     open before a re-render. */
  function openPanel(toggle) {
    var panel = panelFor(toggle);
    if (!panel) return;
    closeAll(toggle);
    toggle.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    var host = panel.offsetParent || panel.parentNode;
    var hr = host.getBoundingClientRect();
    var r = toggle.getBoundingClientRect();
    panel.style.top = Math.round(r.bottom - hr.top + 8) + 'px';
    if (window.innerWidth >= 750) {
      // under the chip, but kept on-screen when the chip sits near the right edge
      panel.style.left = Math.min(Math.round(r.left - hr.left), Math.max(0, Math.round(hr.width) - 340)) + 'px';
    } else {
      panel.style.left = '';
    }
    syncNav();
    restoreFocus(panel); // a11y: re-focus the option that was activated before a re-render
  }
  /* The id (aria-controls) of the chip whose panel is open, or ''. Panel ids
     are index-based and stable across re-renders of the same facet set. */
  function openPanelId() {
    var t = document.querySelector('[data-facet-popout-toggle][aria-expanded="true"]');
    return t ? t.getAttribute('aria-controls') || '' : '';
  }
  window.spejder = window.spejder || {};
  window.spejder.facetChips = { openPanel: openPanel, openPanelId: openPanelId };

  /* Keyboard flow (WCAG 2.1.1 / 2.4.3). The panels live in a separate layer
     after ALL the chips (see the iOS note above), so a plain Tab from an open
     chip would visit every remaining chip before reaching its options. Focus
     is managed instead: Tab from an open chip enters its panel; Tab past the
     last option (or Shift+Tab before the first) closes the panel and continues
     from the chip; Escape closes and returns focus to the chip. Activating an
     option re-renders the toolbar, so the option that had focus is re-focused
     by label on the fresh panel (pendingFocus, consumed in openPanel). */
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var pendingFocus = null;
  function focusablesIn(panel) {
    return [].filter.call(panel.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetWidth || el.offsetHeight || el.getClientRects().length;
    });
  }
  function openToggle() {
    return document.querySelector('[data-facet-popout-toggle][aria-expanded="true"]');
  }
  /* Remember the option that has keyboard focus so the fresh panel after a
     re-render can re-focus its equivalent (called before the filter is applied). */
  function rememberFocus(link) {
    var ownerPanel = link && link.closest ? link.closest('[data-facet-panel]') : null;
    if (!ownerPanel || document.activeElement !== link) return;
    pendingFocus = { panelId: ownerPanel.id, label: (link.textContent || '').trim() };
    setTimeout(function () { pendingFocus = null; }, 5000);
  }
  window.spejder.facetChips.rememberFocus = rememberFocus;
  function restoreFocus(panel) {
    if (!pendingFocus || pendingFocus.panelId !== panel.id) return;
    var want = pendingFocus; pendingFocus = null;
    var match = focusablesIn(panel).filter(function (el) { return (el.textContent || '').trim() === want.label; })[0];
    // No scroll on focus: keepPanel below puts the list back where it was,
    // and the option that had focus was in view there.
    if (match) match.focus({ preventScroll: true });
  }

  /* A scrolled dropdown stays still when a value is applied (Magnus
     2026-10-09: "the list jumps a bit up or down"). The apply re-renders the
     toolbar, so the panel the shopper scrolled is replaced by a fresh one at
     the top, and re-focusing the clicked option then scrolled it just into
     view. capturePanel notes where an option sits inside the open panel (the
     one just activated, then every visible one as fallbacks, in case a value
     drops out); keepPanel scrolls the fresh panel so the first of them still
     there sits at the same spot. Also wrapped around the in-stock pass, which
     removes values from an open panel. */
  var lastOption = null; // { panelId, key } of the option the shopper just activated
  function optionKey(a) {
    return (a.getAttribute('data-param') || '') + '\u0000' + (a.getAttribute('data-value') || '');
  }
  function optionsIn(panel) {
    return [].slice.call(panel.querySelectorAll('a.spejder-facet-popout__option[data-param]'));
  }
  function capturePanel(panel) {
    if (!panel || panel.hidden) return null;
    var pr = panel.getBoundingClientRect();
    var anchors = [];
    optionsIn(panel).forEach(function (a) {
      var r = a.getBoundingClientRect();
      var key = optionKey(a);
      var entry = { key: key, offset: r.top - pr.top };
      if (lastOption && lastOption.panelId === panel.id && lastOption.key === key) anchors.unshift(entry);
      else if (r.bottom > pr.top && r.top < pr.bottom) anchors.push(entry);
    });
    return { panelId: panel.id, scrollTop: panel.scrollTop, anchors: anchors };
  }
  function keepPanel(panel, state) {
    if (!panel || panel.hidden || !state || state.panelId !== panel.id) return;
    var byKey = {};
    optionsIn(panel).forEach(function (a) { byKey[optionKey(a)] = a; });
    for (var i = 0; i < state.anchors.length; i++) {
      var a = byKey[state.anchors[i].key];
      if (!a) continue;
      panel.scrollTop += a.getBoundingClientRect().top - panel.getBoundingClientRect().top - state.anchors[i].offset;
      return;
    }
    panel.scrollTop = state.scrollTop;
  }
  window.spejder.facetChips.capturePanel = capturePanel;
  window.spejder.facetChips.keepPanel = keepPanel;

  /* Route a filter URL through the theme's collection-filters-form element
     (assets/collection-filters-form.js): submitForm(null, url) pushes the URL
     and fetches the page, then swaps [data-products-grid] and
     [data-collection-sidebar]. Returns false when the element is missing so
     the caller falls back to a plain navigation. */
  function ajaxFilter(url) {
    var el = document.querySelector('collection-filters-form');
    if (!el || typeof el.submitForm !== 'function') return false;
    try {
      el.submitForm(null, url);
    } catch (err) {
      return false;
    }
    return true;
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var toggle = e.target.closest('[data-facet-popout-toggle]');
    if (toggle) {
      var panel = panelFor(toggle);
      if (!panel) return;
      var open = toggle.getAttribute('aria-expanded') === 'true';
      if (open) {
        closeAll(null);
      } else {
        openPanel(toggle);
        // detail === 0: activated from the keyboard (Enter/Space) → enter the panel
        if (e.detail === 0) {
          var first = focusablesIn(panel)[0];
          if (first) first.focus();
        }
      }
      return;
    }
    // Option / active pill / "Ryd alle": same-origin filter links → AJAX.
    var link = e.target.closest('a.spejder-facet-popout__option, a.spejder-facet-active__pill, a.spejder-facet-active__clear');
    // A greyed-out value has nothing to show. pointer-events stops the mouse
    // only; Enter on a focused option would still apply it.
    if (link && link.classList.contains('is-disabled')) {
      e.preventDefault();
      return;
    }
    if (link && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey && e.button === 0) {
      var href = link.getAttribute('href') || '';
      if (href.charAt(0) === '/' && ajaxFilter(href)) {
        e.preventDefault();
        // Optimistic state while the section renders: the option flips (or
        // the pill disappears) on the click itself; the fresh markup that
        // lands a moment later carries the authoritative state.
        if (link.classList.contains('spejder-facet-popout__option')) {
          rememberFocus(link);
          var ownerPanel = link.closest('[data-facet-panel]');
          lastOption = ownerPanel ? { panelId: ownerPanel.id, key: optionKey(link) } : null;
          var on = link.classList.toggle('is-active');
          if (on) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        } else if (link.classList.contains('spejder-facet-active__pill')) {
          link.remove();
        }
        return;
      }
    }
    if (!e.target.closest('.spejder-facet-popout__panel')) closeAll(null);
  });
  // Outside-close on the touch/pointer itself, not only on click: iOS Safari
  // synthesises a click for a tap on a NON-clickable element only in some
  // cases, so a delegated click on document never saw taps on blank page
  // areas — the panel stayed open until a chip was tapped again. pointerdown
  // fires for every touch (and for the start of a page swipe, which is how
  // the old scroll-close behaved). Toggles and panels are excluded.
  document.addEventListener('pointerdown', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('[data-facet-popout-toggle]') || e.target.closest('.spejder-facet-popout__panel')) return;
    closeAll(null);
  }, { passive: true });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var openT = openToggle();
      closeAll(null);
      if (openT) openT.focus();
      return;
    }
    if (e.key !== 'Tab' || !e.target || !e.target.closest) return;
    var t = e.target.closest('[data-facet-popout-toggle]');
    if (t && !e.shiftKey && t.getAttribute('aria-expanded') === 'true') {
      var p = panelFor(t);
      var firstEl = p ? focusablesIn(p)[0] : null;
      if (firstEl) { e.preventDefault(); firstEl.focus(); }
      return;
    }
    var panel = e.target.closest('[data-facet-panel]');
    if (!panel) return;
    var items = focusablesIn(panel);
    var owner = document.querySelector('[data-facet-popout-toggle][aria-controls="' + panel.id + '"]');
    if (!owner) return;
    if (e.shiftKey && e.target === items[0]) {
      e.preventDefault();
      closeAll(null);
      owner.focus();
    } else if (!e.shiftKey && e.target === items[items.length - 1]) {
      // Focus the chip and let the default Tab carry on to whatever follows it.
      closeAll(null);
      owner.focus();
    }
  });
  // Pris form: drop empty min/max fields so they don't land in the URL, and
  // apply through the AJAX path when it is available.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('spejder-facet-popout__price')) return;
    form.querySelectorAll('input[type="number"]').forEach(function (i) {
      if (i.value === '') i.disabled = true;
    });
    var action = form.getAttribute('action') || window.location.pathname;
    if (action.charAt(0) !== '/') return;
    var qs = new URLSearchParams(new FormData(form)).toString();
    if (ajaxFilter(action + (qs ? '?' + qs : ''))) {
      e.preventDefault();
      // Re-enable the fields; the panel is re-rendered by the toolbar sync,
      // but until then the shopper may edit and apply again.
      form.querySelectorAll('input[type="number"]').forEach(function (i) { i.disabled = false; });
    }
  }, true);
})();

/* PLP product-type circles — UNIVERSAL image fallback. Server-side a tile's
   image resolves: type's own collection → scan of the currently rendered
   product page → curated cat-*.png asset. A type with none of those rendered
   a blank circle — yet its image provably exists, because a product-type
   filter value only exists when matching products do: applying the tile's own
   filter always surfaces them. So for any circle still empty once images have
   settled, fetch the tile's own filter-apply URL through the product grid's
   section (Section Rendering API, section id read from the DOM — nothing
   hardcoded) and lift the first product-card image out of the response. This
   is the exact same data the selected state displays, just fetched eagerly. */
(function () {
  /* Rewrite a Shopify CDN image URL to the width this circle needs. Non-CDN
     or unparseable URLs pass through untouched. */
  function sizedForCircle(src, w) {
    if (!src || src.indexOf('/cdn/') === -1) return src;
    try {
      var u = new URL(src, location.origin);
      u.searchParams.delete('height');
      u.searchParams.delete('crop');
      u.searchParams.set('width', String(w));
      return u.pathname + u.search;
    } catch (e) {
      return src;
    }
  }
  function lift(item, circle, sectionId) {
    var href = item.getAttribute('href');
    if (!href || href.charAt(0) !== '/') return;
    // url_to_add keeps already-active type filters (OR facet), so the first
    // product of the combined result could belong to the OTHER active type.
    // Keep only this tile's own type value: the one absent from the current URL.
    var u = new URL(href, location.origin);
    var TYPE = 'filter.p.product_type';
    var current = new URLSearchParams(location.search).getAll(TYPE);
    var own = u.searchParams.getAll(TYPE).filter(function (v) { return current.indexOf(v) === -1; });
    if (own.length) {
      u.searchParams.delete(TYPE);
      own.forEach(function (v) { u.searchParams.append(TYPE, v); });
    }
    u.searchParams.delete('page');
    u.searchParams.set('section_id', sectionId);
    fetch(u.pathname + u.search)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var img = doc.querySelector('.product-item img');
        if (!img) return;
        var src = img.getAttribute('src') || img.getAttribute('data-src') || '';
        if (!src) {
          var ss = img.getAttribute('srcset') || img.getAttribute('data-srcset') || '';
          if (ss) src = ss.split(',')[0].trim().split(' ')[0];
        }
        if (!src) return;
        var out = document.createElement('img');
        out.alt = '';
        out.width = 160;
        out.height = 160;
        /* The scraped card <img> carries the card's own full-size src — the
           grid renders at ~335px, and its `src` (as opposed to the srcset the
           browser would have picked) is the unresized original: a 1600x1600
           product photo arrived to fill a 78px circle, 2.5 megapixels to
           decode. Re-ask the CDN for the size this circle actually needs; 320
           covers the 160px tile on a 2x display. crop/height come off with it
           or Shopify keeps honouring the original square crop request. */
        out.src = sizedForCircle(src, 320);
        circle.innerHTML = '';
        circle.appendChild(out);
      })
      .catch(function () {});
  }
  function sectionId() {
    // Anchor on the collection section itself — the first .product-item in the
    // DOM belongs to the header search popdown, and the cart drawer holds more.
    var main = document.querySelector('[data-section-type="collection"]');
    var sec = main && main.closest('.shopify-section');
    return sec && sec.id ? sec.id.replace(/^shopify-section-/, '') : null;
  }
  function maybeLift(item) {
    if (!item || item.dataset.imgLifted || item.classList.contains('is-active')) return;
    var circle = item.querySelector('.spejder-category-links__circle');
    if (!circle) return;
    var img = circle.querySelector('img');
    // A real image present or still pending (lazy images stay pending until
    // scrolled into view) — leave it; the error listener below owns the
    // pending case if it eventually fails.
    if (img && !(img.complete && img.naturalWidth === 0)) return;
    var sid = sectionId();
    if (!sid) return;
    item.dataset.imgLifted = '1';
    lift(item, circle, sid);
  }
  function sweep() {
    document.querySelectorAll('.spejder-category-links--product-types .spejder-category-links__item').forEach(maybeLift);
  }
  // EVENT-driven, not timer-driven: lazy circle images only load — and only
  // FAIL — once scrolled into view, which can be long after any load-time
  // sweep (the original bug: circles stayed blank when the row entered the
  // viewport late). error doesn't bubble, so listen in capture phase; this
  // fires BEFORE the img's own inline onerror (which removes it / swaps to
  // its product fallback), so defer the check one tick.
  document.addEventListener('error', function (e) {
    var img = e.target;
    if (!img || img.tagName !== 'IMG') return;
    if (!img.closest) return;
    var item = img.closest('.spejder-category-links--product-types .spejder-category-links__item');
    if (!item) return;
    // If the inline onerror is about to swap to a product-image fallback,
    // let it — unless this failure IS the fallback itself.
    if (img.dataset.productFallback && img.src.indexOf(img.dataset.productFallback) === -1) return;
    setTimeout(function () { maybeLift(item); }, 0);
  }, true);
  // Sweeps still cover images that already failed before listeners attached
  // and tiles the server rendered with no img at all.
  if (document.readyState !== 'loading') sweep();
  else document.addEventListener('DOMContentLoaded', sweep);
  window.addEventListener('load', sweep);
})();

(function () {
  // Kundeklub dashboard — order history pager (desktop: Side x/y arrows,
  // mobile: Vis mere reveals the next chunk). Rows stay in the DOM; only
  // visibility flips, so no fetches and no layout jumps.
  function initKlubOrders() {
    document.querySelectorAll('[data-member-orders]').forEach(function (wrap) {
      var rows = Array.prototype.slice.call(wrap.querySelectorAll('[data-member-order]'));
      var pp = parseInt(wrap.dataset.perPage || '2', 10) || 2;
      var pages = Math.ceil(rows.length / pp);
      var page = 0;
      var shown = pp;
      var pager = wrap.querySelector('[data-member-orders-pager]');
      var label = wrap.querySelector('[data-member-orders-label]');
      var prev = wrap.querySelector('[data-member-orders-prev]');
      var next = wrap.querySelector('[data-member-orders-next]');
      var more = wrap.querySelector('[data-member-orders-more]');
      // Bound to the dashboard's CSS single-column stack (assets/spejder.css
      // .spejder-member-dashboard__layout etc, all @media max-width:989px) —
      // NOT the theme's generic 749px tier. Card y2bad2FH: CSS-only would
      // leave 750-989 showing "Vis mere" while this stayed in desktop paging
      // mode, so the button would do nothing and page 2+ would be
      // unreachable. isMobile() below (cart-drawer redirect) is a separate,
      // unrelated concern and stays at 749.
      var mq = window.matchMedia('(max-width: 989px)');
      function render() {
        var mobile = mq.matches;
        rows.forEach(function (row, i) {
          row.hidden = mobile ? i >= shown : (i < page * pp || i >= (page + 1) * pp);
        });
        // Card y2bad2FH QA fixture caught: pager visibility ignored `mobile`,
        // so at <=989 with >1 page of orders BOTH the desktop Prev/Next pager
        // AND "Vis mere" rendered at once (double-exposed control, same bug
        // pre-existed at <=749 before this card). Pager is desktop-only.
        if (pager) pager.hidden = mobile || pages <= 1;
        if (label) label.textContent = 'Side ' + (page + 1) + ' / ' + pages;
        if (prev) prev.disabled = page === 0;
        if (next) next.disabled = page >= pages - 1;
        if (more) more.hidden = mobile ? shown >= rows.length : true;
      }
      if (prev) prev.addEventListener('click', function () { if (page > 0) { page -= 1; render(); } });
      if (next) next.addEventListener('click', function () { if (page < pages - 1) { page += 1; render(); } });
      if (more) more.addEventListener('click', function () { shown += pp; render(); });
      if (mq.addEventListener) mq.addEventListener('change', render);
      // Old receipts (assets/spejder-member-dashboard.js) are appended after
      // load, so the list can start empty and grow: re-count on its event.
      wrap.addEventListener('spejder:member-orders:changed', function () {
        rows = Array.prototype.slice.call(wrap.querySelectorAll('[data-member-order]'));
        pages = Math.ceil(rows.length / pp);
        render();
      });
      if (rows.length) render();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKlubOrders);
  } else {
    initKlubOrders();
  }
})();

(function () {
  // Kundeklub dashboard — sticky rail height feed. assets/spejder.css
  // .spejder-member-dashboard__rail pins to the top while it fits the
  // viewport and to the bottom once it is taller (min() on `top`); the
  // taller-than-viewport branch needs the rail's content height, which CSS
  // can't know. Measured from the rail's top to its last card's bottom, so
  // the rail's own 56px bottom pad (Figma page-end alignment) stays out of
  // the pin maths. Re-measured on every size change (pager flips, drawer
  // content, viewport resize). On the ≤989px single-column stack the rail
  // is display:contents (no box) — the observer reports 0 and the CSS
  // fallback path is taken, which is harmless since sticky is off there.
  function initKlubRail() {
    var rails = document.querySelectorAll('.spejder-member-dashboard__rail');
    if (!rails.length) return;
    rails.forEach(function (rail) {
      function measure() {
        var last = rail.lastElementChild;
        var h = 0;
        if (last && rail.getClientRects().length) {
          h = Math.max(0, Math.round(last.getBoundingClientRect().bottom - rail.getBoundingClientRect().top));
        }
        rail.style.setProperty('--member-rail-height', h + 'px');
      }
      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(measure);
        ro.observe(rail);
        Array.prototype.forEach.call(rail.children, function (child) { ro.observe(child); });
      }
      window.addEventListener('resize', measure);
      window.addEventListener('load', measure);
      measure();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKlubRail);
  } else {
    initKlubRail();
  }
})();

(function () {
  // Kundeklub dashboard — rabatkode copy button: clipboard + 2s "Kopieret!" state
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-member-copy]');
    if (!btn) return;
    var code = btn.dataset.code || '';
    var label = btn.querySelector('[data-member-copy-label]');
    function confirmCopied() {
      if (!label) return;
      if (!label.dataset.orig) label.dataset.orig = label.textContent;
      label.textContent = btn.dataset.copiedLabel || 'Kopieret!';
      btn.classList.add('is-copied');
      clearTimeout(btn._copyTimer);
      btn._copyTimer = setTimeout(function () {
        label.textContent = label.dataset.orig;
        btn.classList.remove('is-copied');
      }, 2000);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(confirmCopied);
    } else {
      var ta = document.createElement('textarea');
      ta.value = code;
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (err) {}
      document.body.removeChild(ta);
      confirmCopied();
    }
  });
})();

(function () {
  /* Kundeklub dashboard "Anbefalet til dig" slider: step = one card + gap,
     arrows grey out (mobile) / hide (desktop, via CSS) at the extremes. */
  function syncKlubSlider(row) {
    var wrap = row.closest('[data-member-slider]');
    if (!wrap) return;
    var prev = wrap.querySelector('[data-member-slider-prev]');
    var next = wrap.querySelector('[data-member-slider-next]');
    var max = row.scrollWidth - row.clientWidth - 1;
    if (prev) prev.classList.toggle('is-disabled', row.scrollLeft <= 0);
    if (next) next.classList.toggle('is-disabled', row.scrollLeft >= max);
  }
  function syncAllKlubSliders() {
    document.querySelectorAll('[data-member-slider-row]').forEach(syncKlubSlider);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-member-slider-prev], [data-member-slider-next]');
    if (!btn) return;
    var row = btn.closest('[data-member-slider]').querySelector('[data-member-slider-row]');
    if (!row) return;
    var card = row.firstElementChild;
    var gap = parseFloat(getComputedStyle(row).columnGap) || 20;
    var step = card ? card.getBoundingClientRect().width + gap : 355;
    row.scrollBy({ left: btn.hasAttribute('data-member-slider-prev') ? -step : step, behavior: 'smooth' });
  });
  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-member-slider-row]')) syncKlubSlider(e.target);
  }, true);
  window.addEventListener('resize', syncAllKlubSliders);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAllKlubSliders);
  } else {
    syncAllKlubSliders();
  }
})();

/* Hide a related-only recommendation row whose async fetch returned nothing
   (card AXlGX5HW). assets/related-products.js is a minified vendor asset with no
   /src counterpart, so it is off-limits; its hideSection() already dispatches a
   bubbling `theme:tab:hide`, but the only listener is <tabs-component>, which the
   PDP does not render (enable_tabs:false). Listen for it here instead. Covers the
   zero-result path and the fetch-error path, since hideSection() serves both.

   The marker class must NOT be `hidden`: related-products.js calls
   updateVisibility() immediately after hideSection(), and that toggles `hidden`
   back off in the same tick (its guard reads the recently-viewed config, which is
   effectively never < 1 on a PDP). The server-side data-hide-when-empty attribute
   scopes this to related-ONLY, tabs-off sections, so a section carrying both
   blocks never loses its recently-viewed half.

   Load order is safe: spejder.js is deferred in head.liquid and
   related-products.js is deferred in the section body, and deferred scripts run
   in document order — this listener is installed before the custom element is
   even defined. */
(function () {
  document.addEventListener('theme:tab:hide', function (e) {
    var target = e.target;
    var section = target && target.closest && target.closest('related-products[data-hide-when-empty]');
    if (section) section.classList.add('related__wrapper--empty');
  });
})();


/* Cart page (mobile): pin-then-dock mini-checkout.
   The bar is rendered inside [data-cart-price-holder] so the theme's AJAX price
   refresh regenerates it (theme.js replaces that holder's innerHTML on every
   qty/remove). But position:sticky can only travel within its PARENT, and the
   holder is a short box — so on load and after every refresh the bar is moved to
   the end of the cart form, where sticky bottom:0 pins it to the viewport until
   its natural position (just before the footer) scrolls into view, then docks.
   If JS never runs, the bar simply stays inside the holder and renders in place. */
(function () {
  var form = document.querySelector('[data-cart-page] form[data-cart-form]');
  var holder = document.querySelector('[data-cart-page] [data-cart-price-holder]');
  if (!form || !holder) return;
  var relocate = function () {
    var fresh = holder.querySelector('.spejder-cart-sticky');
    if (!fresh) return;
    var live = form.querySelector(':scope > .spejder-cart-sticky');
    if (live) live.remove();
    form.appendChild(fresh);
  };
  relocate();
  new MutationObserver(relocate).observe(holder, { childList: true, subtree: true });
})();

/* Cart page: "Accepter handelsbetingelser" gate (snippets/spejder-cart-terms.liquid,
   client card Dzx3R1cU — moved here from the checkout, where Apple Pay's express
   button opened before the box could be checked). The row renders twice (desktop
   aside + mobile sticky bar, one visible at a time) and shares ONE state; the
   sticky copy comes back unticked from every AJAX price refresh, so the observer
   re-applies it. Both GÅ TIL KASSEN buttons are name="checkout" submits, and a
   cancelled click also cancels the Enter-key submission that clicks them.
   The cart drawer's form gets the same gate when Theme settings → Cart →
   "Checkout from cart drawer" puts the box and a checkout submit in it
   (2026-10-23). Each form keeps its own state; the theme refreshes only the
   holders inside the drawer's form, never the form itself. */
document.querySelectorAll('form[data-cart-form]').forEach(function (form) {
  if (!form.querySelector('[data-spejder-cart-terms-input]')) return;
  var accepted = false;
  var blocked = false;
  var render = function () {
    form.querySelectorAll('[data-spejder-cart-terms]').forEach(function (row) {
      var box = row.querySelector('[data-spejder-cart-terms-input]');
      box.checked = accepted;
      box.setAttribute('aria-invalid', blocked ? 'true' : 'false');
      row.classList.toggle('is-invalid', blocked);
      row.querySelector('[data-spejder-cart-terms-error]').hidden = !blocked;
    });
  };
  form.addEventListener('change', function (e) {
    if (!e.target.matches('[data-spejder-cart-terms-input]')) return;
    accepted = e.target.checked;
    blocked = false;
    render();
  });
  form.addEventListener('click', function (e) {
    if (accepted || !e.target.closest('[name="checkout"]')) return;
    e.preventDefault();
    blocked = true;
    render();
    var shown = Array.prototype.filter.call(form.querySelectorAll('[data-spejder-cart-terms]'), function (row) {
      return row.offsetParent !== null;
    })[0];
    if (shown) shown.querySelector('[data-spejder-cart-terms-input]').focus();
  });
  new MutationObserver(render).observe(form, { childList: true, subtree: true });
});

/* Filter drawer "Vis flere / Vis færre" toggle (Emil 2026-08-18). Replaces
   the theme's one-shot [data-show-more]: that bound once per page-load (dead
   after the sidebar's AJAX innerHTML swap on every filter change) and could
   only expand. Delegated on document so it works on every re-render; toggles
   the capped values in the ul that precedes the actions row (the markup
   contract filter-values-list.liquid already guarantees). */
(function () {
  function setExpanded(toggle, expanded) {
    var actions = toggle.closest('.collection__sidebar__actions');
    var list = actions && actions.previousElementSibling;
    if (!list) return;
    toggle.classList.toggle('is-expanded', expanded);
    list.querySelectorAll('[data-link-hidden]').forEach(function (item) {
      item.classList.toggle('hidden', !expanded);
    });
    var more = toggle.querySelector('[data-toggle-label-more]');
    var less = toggle.querySelector('[data-toggle-label-less]');
    if (more) more.hidden = expanded;
    if (less) less.hidden = !expanded;
  }
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('[data-spejder-show-toggle]');
    if (!toggle) return;
    e.preventDefault();
    var expanded = !toggle.classList.contains('is-expanded');
    setExpanded(toggle, expanded);
    // Collapsing can leave the scroll position past the shortened group —
    // keep the group's heading in view so the user isn't stranded.
    if (!expanded) {
      var group = toggle.closest('.filter-group');
      if (group && group.getBoundingClientRect().top < 0) {
        group.scrollIntoView({ block: 'start' });
      }
    }
  });

  /* Drawer state across the AJAX swap (Magnus 2026-09-08): the theme's
     collection-filters-form fetch replaces [data-collection-sidebar]'s whole
     innerHTML after every filter change, so the accordion the shopper was
     ticking in snapped shut (open state comes only from the section's
     "default open" settings), any expanded "Vis flere" list collapsed and
     the drawer scrolled back to the top — it read as a page reload even
     though it was not. Snapshot the open groups (by heading label), the
     expanded lists and the scroll offsets right when the filter JS pushes
     the new URL (the DOM is still the old one then), and re-apply them to
     the fresh markup the moment the swap lands. Groups are re-opened
     instantly (height:auto, exactly how Liquid renders a default-open group)
     so nothing animates or moves. */
  var sidebar = document.querySelector('[data-collection-sidebar]');
  if (!sidebar) return;
  var snap = null;

  function labelOf(group) {
    var span = group.querySelector('[data-collapsible-trigger] span');
    return span ? span.textContent.trim() : '';
  }
  function isOpen(group) {
    return group.hasAttribute('open') && group.getAttribute('open') !== 'false';
  }
  function scrollers() {
    return [sidebar].concat([].slice.call(sidebar.querySelectorAll('[data-scroll-lock-scrollable]')));
  }

  /* The scroll offset alone is not enough (Magnus 2026-10-09: "the list
     jumps"): values with no product are not listed, so ticking a brand
     shrinks the Størrelse group above it (and unticking grows it back), and
     the same offset then shows other values. Like the chip dropdowns
     (capturePanel/keepPanel), note where a value sits in each scroller (the
     one just changed first, then every visible one as fallbacks) and scroll
     the fresh drawer so the first of them still there sits at the same spot.
     Also used around the in-stock pass, which removes values. */
  var lastInput = null; // name + value of the drawer value the shopper just changed
  function inputKey(input) {
    return input.name + '\u0000' + input.value;
  }
  // Capture phase on 'input': the theme applies the filter from its own
  // 'input' listener on this same element (before 'change' even fires), and
  // the snapshot is taken in that apply, so the value must be known first.
  sidebar.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.name && t.name.indexOf('filter.') === 0) lastInput = inputKey(t);
  }, true);
  function anchorsIn(el) {
    var er = el.getBoundingClientRect();
    var list = [];
    el.querySelectorAll('li.sidebar__item > input[name][value]').forEach(function (input) {
      var r = input.parentElement.getBoundingClientRect();
      if (!r.height) return; // in a closed group or past a "Vis flere" cap
      var entry = { key: inputKey(input), offset: r.top - er.top };
      if (entry.key === lastInput) list.unshift(entry);
      else if (r.bottom > er.top && r.top < er.bottom) list.push(entry);
    });
    return list;
  }
  function reanchor(el, anchors) {
    if (!anchors || !anchors.length) return false;
    var byKey = {};
    el.querySelectorAll('li.sidebar__item > input[name][value]').forEach(function (input) {
      if (input.parentElement.getBoundingClientRect().height) byKey[inputKey(input)] = input.parentElement;
    });
    for (var i = 0; i < anchors.length; i++) {
      var li = byKey[anchors[i].key];
      if (!li) continue;
      el.scrollTop += li.getBoundingClientRect().top - el.getBoundingClientRect().top - anchors[i].offset;
      return true;
    }
    return false;
  }
  function onScreen(el) {
    // Only an element that really scrolls (the slide-out wrapper does not),
    // and not while the closed slide-out sits off-canvas.
    if (!/(auto|scroll)/.test(getComputedStyle(el).overflowY)) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.right > 0 && r.left < window.innerWidth;
  }
  function captureScroll() {
    return scrollers().map(function (el) { return { top: el.scrollTop, anchors: onScreen(el) ? anchorsIn(el) : [] }; });
  }
  function keepScroll(state) {
    if (!state) return;
    scrollers().forEach(function (el, i) {
      var s = state[i];
      if (!s) return;
      if (!reanchor(el, s.anchors) && s.top) el.scrollTop = s.top;
    });
  }
  window.spejder = window.spejder || {};
  window.spejder.drawerScroll = { capture: captureScroll, keep: keepScroll };

  function take() {
    var open = [];
    var expanded = [];
    sidebar.querySelectorAll('[data-collapsible]').forEach(function (group) {
      var label = labelOf(group);
      if (!label) return;
      if (isOpen(group)) open.push(label);
      if (group.querySelector('[data-spejder-show-toggle].is-expanded')) expanded.push(label);
    });
    snap = {
      open: open,
      expanded: expanded,
      scroll: captureScroll(),
    };
  }
  function restore() {
    if (!snap) return;
    var state = snap;
    snap = null;
    sidebar.querySelectorAll('[data-collapsible]').forEach(function (group) {
      var label = labelOf(group);
      if (!label) return;
      if (state.open.indexOf(label) !== -1 && !isOpen(group)) {
        group.setAttribute('open', 'true');
        var trigger = group.querySelector('[data-collapsible-trigger]');
        var body = group.querySelector('[data-collapsible-body]');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        if (body) body.style.height = 'auto';
      }
      if (state.expanded.indexOf(label) !== -1) {
        var toggle = group.querySelector('[data-spejder-show-toggle]');
        if (toggle && !toggle.classList.contains('is-expanded')) setExpanded(toggle, true);
      }
    });
    keepScroll(state.scroll);
  }

  var origPushState = window.history.pushState;
  window.history.pushState = function () {
    take();
    return origPushState.apply(this, arguments);
  };
  window.addEventListener('popstate', take);
  new MutationObserver(restore).observe(sidebar, { childList: true });
})();

/* Filter accordions open into view (Magnus Gravenhorst 2026-10-19, "Bedre
   UX på filter"): a group opened near the drawer's bottom edge unfolded
   below it, so clicking + seemed to do nothing. While the theme's height
   transition runs, scroll the drawer just enough each frame to keep the
   group's bottom on screen, never past its heading, so a group taller than
   the drawer stops with its heading at the top. Delegated on document: one
   listener covers the S&D drawer and the Relewise search drawer, and
   survives the AJAX swaps of their markup. */
(function () {
  document.addEventListener('theme:collapsible:toggle', function (e) {
    var group = e.target;
    if (!group.closest || !group.closest('#filter-groups')) return;
    if (group.getAttribute('open') !== 'true') return;
    var scroller = group.closest('[data-scroll-lock-scrollable]');
    var heading = group.querySelector('[data-collapsible-trigger]');
    var body = group.querySelector('[data-collapsible-body]');
    if (!scroller || !heading || !body) return;
    var stop = Date.now() + 1000; // backstop in case transitionend never comes
    (function follow() {
      if (group.getAttribute('open') !== 'true') return; // closed again mid-way
      var view = scroller.getBoundingClientRect();
      var below = group.getBoundingClientRect().bottom - view.bottom;
      var room = heading.getBoundingClientRect().top - view.top;
      var step = Math.min(below, room);
      if (step > 0) scroller.scrollTop += step;
      // The theme sets height:auto on transitionend; this pass saw the full height.
      if (body.style.height !== 'auto' && Date.now() < stop) requestAnimationFrame(follow);
    })();
  });
})();

/* Filter render — ONE section fetch, no scroll jump (Magnus 2026-09-08).

   The theme's collection-filters-form (assets/collection-filters-form.js)
   fetched the FULL page on every filter change, swapped the grid + drawer,
   and then scrolled the window to the top of the grid; the toolbar sync
   (Emil 2026-08-18) fetched the same URL a second time through the Section
   Rendering API to refresh the chips/pills/counts it had left stale. Two
   round trips per apply, and a scroll jump the shopper never asked for.

   submitForm() is replaced on the element's prototype (every theme path —
   drawer checkbox, price slider, sort, url buttons, popstate — funnels
   through it, so nothing else in the vendor file needs touching): same URL
   maths, one ?section_id= fetch (the section only, not header/footer/menus),
   and every piece re-rendered from that single response: grid, results
   count, drawer, active-filter badges, quick-filter chips + their value
   panels, the "Ryd alle" row and the "X varer" counts. The chip dropdown
   that was open re-opens on its fresh panel; the drawer-state block above
   restores the accordions. The window is never scrolled. Stale responses
   (a second click before the first lands) are dropped. Falls back to the
   theme's own submitForm when the section id cannot be found. */
(function () {
  var TOOLBAR_PARTS = ['[data-facet-chips]', '[data-facet-panels]'];

  /* Hover-intent prefetch. The wait on a filter apply is Shopify rendering
     the section (32 cards + facets: ~0.6-0.9 s via the dev proxy, TTFB is
     all of it), so the only real cut is to START the render before the
     click: after a short hover over a chip option or a drawer value the
     section URL it would apply is fetched into a small, short-lived cache
     that render() consumes. One prefetch in flight at a time, so sweeping
     the pointer across a list does not fan out requests. */
  var CACHE_MAX = 12;
  var CACHE_TTL = 60 * 1000;
  var cache = {}; // sectionUrl -> { at, promise }
  var cacheKeys = [];
  function cachedFetch(sectionUrl) {
    var hit = cache[sectionUrl];
    if (hit && Date.now() - hit.at < CACHE_TTL) return hit.promise;
    var promise = fetch(sectionUrl).then(function (r) {
      if (!r.ok) throw new Error('section ' + r.status);
      return r.text();
    });
    promise.catch(function () { delete cache[sectionUrl]; });
    cache[sectionUrl] = { at: Date.now(), promise: promise };
    cacheKeys.push(sectionUrl);
    while (cacheKeys.length > CACHE_MAX) delete cache[cacheKeys.shift()];
    return promise;
  }
  function sectionUrlFor(pageUrl, sid) {
    var u = new URL(pageUrl, window.location.href); // '?x=y' resolves against the current path
    u.searchParams.set('section_id', sid);
    return u.pathname + u.search;
  }

  function queryDelete(params, test) {
    Array.from(new Set(params.keys())).forEach(function (k) {
      if (test(k)) params.delete(k);
    });
  }

  /* Filtering shows products in stock only (client card "Nedprioriter
     udsolgte produkter", 2026-10-06). The section setting "Filtering shows
     products in stock only" puts data-filters-in-stock on the section. The
     first filter a shopper picks brings Search & Discovery's availability
     filter ("Kun på lager") along, so a filtered grid holds no sold-out
     products. The added "Kun på lager" gets no "Ja" pill in the active row
     (client 2026-10-07: shoppers must not remove it — spejder-facet-chips /
     collection-filters-sidebar never show a "Ja" pill, Magnus 2026-10-09).
     Removing the last filter removes the added "Kun på lager" too. The history entry remembers
     that the theme added it (state.spejderAutoStock). A "Kun på lager" the
     shopper picked or removed themselves is left alone. */
  var STOCK_PARAM = 'filter.v.availability';
  function hasOtherFilters(params) {
    return Array.from(params.keys()).some(function (k) {
      return k.indexOf('filter.') === 0 && k !== STOCK_PARAM;
    });
  }
  function inStockUrl(container, url) {
    if (!container || !container.hasAttribute('data-filters-in-stock')) return { url: url, auto: false };
    var next = new URL(url, window.location.href);
    var params = next.searchParams;
    var added = !!(window.history.state && window.history.state.spejderAutoStock);
    var filtering = hasOtherFilters(params);
    if (filtering && !params.has(STOCK_PARAM) && !hasOtherFilters(new URLSearchParams(window.location.search))) {
      params.append(STOCK_PARAM, '1');
      return { url: next.pathname + next.search, auto: true };
    }
    if (added && !filtering && params.has(STOCK_PARAM)) {
      params.delete(STOCK_PARAM);
      return { url: next.pathname + next.search, auto: false };
    }
    return { url: url, auto: added && params.has(STOCK_PARAM) };
  }

  /* In-stock counts (Magnus 2026-10-06, filter QA). Before the first filter,
     Shopify counts sold-out products too, while the first filter brings
     "Kun på lager" along (inStockUrl above): a value could say 4 and give
     "0 varer", and Shopify's own count on Kun på lager came out low (Mænd
     "Ja 461", ticked: 480 varer). So a page without Kun på lager fetches
     itself once more with it, and takes the counts shown from that answer,
     where Shopify's numbers match what a click returns:
       - no filter yet: every value's count; a value with nothing in stock
         goes (dropEmpty);
       - filters without Kun på lager (the shopper switched it off): only the
         "Ja" count, since the other values do not bring it along then.
     Links and active states stay as rendered. */
  function countKey(name, value) {
    return name + '\u0000' + value;
  }
  function readCounts(root) {
    var counts = {};
    root.querySelectorAll('[data-collection-sidebar] li.sidebar__item > input[name][value]').forEach(function (input) {
      var count = input.parentElement.querySelector('.chip__count');
      if (count) counts[countKey(input.name, input.value)] = parseInt(count.textContent, 10) || 0;
    });
    root.querySelectorAll('a.spejder-facet-popout__option[data-param]').forEach(function (link) {
      var count = link.querySelector('.spejder-facet-popout__count');
      if (count) counts[countKey(link.getAttribute('data-param'), link.getAttribute('data-value'))] = parseInt(count.textContent, 10) || 0;
    });
    return counts;
  }
  /* A value with nothing in stock is not listed, not even greyed out, on any
     facet (client card MHDBArN1 + Magnus 2026-10-07). filter-values-list and
     spejder-facet-chips leave out the values Shopify already counts 0; the
     ones only the in-stock count brings to 0 go here (with onlyStock: just
     "Ja"). What they leave behind goes too: an emptied size section and its
     heading, a Brand letter with no brand under it, the "Vis flere" a drawer
     list no longer needs (its cap is re-applied, data-value-cap), and a
     facet's chip and drawer group once nothing is left in them. */
  function dropEmpty(container, counts, onlyStock) {
    function gone(param, value) {
      return (!onlyStock || param === STOCK_PARAM) && !counts[countKey(param, value)];
    }
    var facets = window.spejder && window.spejder.facetChips;
    container.querySelectorAll('[data-facet-panel]').forEach(function (panel) {
      var options = panel.querySelectorAll('a.spejder-facet-popout__option[data-param]');
      if (!options.length) return; // Pris: a form, no options
      // An open dropdown keeps its scroll spot while values drop out of it.
      var kept = facets && facets.capturePanel ? facets.capturePanel(panel) : null;
      options.forEach(function (link) {
        if (!link.classList.contains('is-active') && gone(link.getAttribute('data-param'), link.getAttribute('data-value'))) link.parentElement.remove();
      });
      panel.querySelectorAll('.spejder-facet-popout__list').forEach(function (list) {
        if (list.children.length) return;
        var heading = list.previousElementSibling;
        if (heading && heading.classList.contains('spejder-facet-popout__subheading')) heading.remove();
        list.remove();
      });
      if (panel.querySelector('.spejder-facet-popout__option')) {
        if (kept) facets.keepPanel(panel, kept);
        return;
      }
      var toggle = container.querySelector('[data-facet-popout-toggle][aria-controls="' + panel.id + '"]');
      var chip = toggle && toggle.closest('[data-facet-popout]');
      if (chip) chip.remove();
      panel.remove();
    });
    // The drawer keeps its scroll spot too while values drop out of it.
    var drawer = window.spejder && window.spejder.drawerScroll;
    var keptDrawer = drawer ? drawer.capture() : null;
    container.querySelectorAll('[data-collection-sidebar] .filter-group').forEach(function (group) {
      var inputs = group.querySelectorAll('li.sidebar__item > input[name][value]');
      if (!inputs.length) return;
      inputs.forEach(function (input) {
        if (!input.checked && gone(input.name, input.value)) input.parentElement.remove();
      });
      group.querySelectorAll('ul.collection-nav').forEach(function (list) {
        list.querySelectorAll('li.collection-nav__index').forEach(function (letter) {
          var next = letter.nextElementSibling;
          if (!next || !next.classList.contains('sidebar__item')) letter.remove();
        });
        var actions = list.nextElementSibling;
        if (actions && !actions.classList.contains('collection__sidebar__actions')) actions = null;
        if (!list.querySelector('.sidebar__item')) {
          var heading = list.previousElementSibling;
          if (heading && heading.classList.contains('filter-group__sublabel')) heading.remove();
          if (actions) actions.remove();
          list.remove();
          return;
        }
        var cap = parseInt(list.getAttribute('data-value-cap'), 10) || 0;
        if (!actions || !cap) return;
        // The first `cap` values show; a letter goes with the value under it.
        var expanded = !!actions.querySelector('[data-spejder-show-toggle].is-expanded');
        var shown = 0;
        [].forEach.call(list.children, function (li) {
          var capped = shown >= cap;
          if (li.classList.contains('sidebar__item')) shown += 1;
          li.toggleAttribute('data-link-hidden', capped);
          li.classList.toggle('hidden', capped && !expanded);
        });
        if (shown <= cap) actions.remove();
      });
      if (group.querySelector('.sidebar__item')) return;
      group.classList.add('filter-group--hidden');
      group.style.display = 'none';
    });
    if (keptDrawer) drawer.keep(keptDrawer);
  }
  function applyCounts(container, counts, onlyStock) {
    dropEmpty(container, counts, onlyStock);
    container.querySelectorAll('a.spejder-facet-popout__option[data-param]').forEach(function (link) {
      var param = link.getAttribute('data-param');
      if (link.classList.contains('is-active') || (onlyStock && param !== STOCK_PARAM)) return;
      var countEl = link.querySelector('.spejder-facet-popout__count');
      if (countEl) countEl.textContent = counts[countKey(param, link.getAttribute('data-value'))] || 0;
    });
    container.querySelectorAll('[data-collection-sidebar] li.sidebar__item > input[name][value]').forEach(function (input) {
      if (input.checked || (onlyStock && input.name !== STOCK_PARAM)) return;
      var countEl = input.parentElement.querySelector('.chip__count');
      if (countEl) countEl.textContent = counts[countKey(input.name, input.value)] || 0;
    });
  }
  var countsSeq = 0;
  function applyInStockCounts(container) {
    if (!container || !container.hasAttribute('data-filters-in-stock')) return;
    var sid = container.getAttribute('data-section-id');
    var params = new URLSearchParams(window.location.search);
    if (!sid || params.has(STOCK_PARAM)) return;
    var onlyStock = hasOtherFilters(params);
    params.append(STOCK_PARAM, '1');
    var search = window.location.search;
    var mine = ++countsSeq;
    cachedFetch(sectionUrlFor(window.location.pathname + '?' + params.toString(), sid))
      .then(function (html) {
        if (mine !== countsSeq || window.location.search !== search) return; // the shopper moved on
        applyCounts(container, readCounts(new DOMParser().parseFromString(html, 'text/html')), onlyStock);
      })
      .catch(function () {}); // the counts as rendered stay
  }

  /* The theme's URL rule for a form submit: keep non-filter params, replace
     every filter./page/sort_by with the form's current values, and drop a
     price range that still spans the full min..max. */
  function urlFromForm(form, formData) {
    var params = new URLSearchParams(window.location.search);
    queryDelete(params, function (k) { return k.indexOf('filter.') !== -1 || k === 'page' || k === 'sort_by'; });
    if (form) {
      var minEl = form.querySelector('[data-se-min-value]');
      var maxEl = form.querySelector('[data-se-max-value]');
      var rangeMin = minEl && minEl.hasAttribute('data-se-min') ? minEl.getAttribute('data-se-min') : '';
      var rangeMax = maxEl && maxEl.hasAttribute('data-se-max') ? maxEl.getAttribute('data-se-max') : '';
      var atEdge = 0;
      new URLSearchParams(formData || new FormData(form)).forEach(function (v, k) {
        if (!v) return;
        if (k.indexOf('filter.') === -1 && k.indexOf('sort_by') === -1) return;
        params.append(k, v);
        if ((k === 'filter.v.price.gte' && v === rangeMin) || (k === 'filter.v.price.lte' && v === rangeMax)) atEdge += 1;
      });
      if (atEdge === 2) {
        params.delete('filter.v.price.gte');
        params.delete('filter.v.price.lte');
      }
      // The drawer renders "Kun på lager" only when it is in "Filter order".
      // When it is missing there, keep the URL's value, or the next drawer
      // change would silently drop an active "Kun på lager".
      if (!form.querySelector('[name="' + STOCK_PARAM + '"]')) {
        new URLSearchParams(window.location.search).getAll(STOCK_PARAM).forEach(function (v) {
          params.append(STOCK_PARAM, v);
        });
      }
    }
    var qs = params.toString();
    // Canonical collection path (snippets/filters.liquid): a legacy handle
    // that redirects keeps only the last value of a repeated filter param.
    var path = (form && form.getAttribute('data-filter-path')) || window.location.pathname;
    return path + (qs ? '?' + qs : '');
  }

  /* The URL a drawer checkbox would apply when toggled (same maths as the
     submit, with that one entry added or removed). */
  function urlWithToggled(form, input) {
    // Flip, serialise, flip back: FormData then carries the entries in DOM
    // order, byte-identical to the URL the real submit builds (cache key).
    input.checked = !input.checked;
    var fd = new FormData(form);
    input.checked = !input.checked;
    return urlFromForm(form, fd);
  }

  function swapInner(root, doc, selector) {
    var cur = root.querySelector(selector);
    var fresh = doc.querySelector(selector);
    if (cur && fresh) cur.innerHTML = fresh.innerHTML;
  }

  function renderToolbar(nav, freshNav) {
    var facets = window.spejder && window.spejder.facetChips;
    var reopen = facets ? facets.openPanelId() : '';
    // Where the open dropdown was scrolled, so the fresh one opens there too.
    var kept = reopen && facets.capturePanel ? facets.capturePanel(document.getElementById(reopen)) : null;
    TOOLBAR_PARTS.forEach(function (sel) {
      var cur = nav.querySelector(sel);
      var fresh = freshNav.querySelector(sel);
      if (cur && fresh) cur.replaceWith(fresh);
    });
    var oldRow = nav.querySelector('[data-facet-active]');
    var newRow = freshNav.querySelector('[data-facet-active]');
    if (oldRow) oldRow.remove();
    var anchor = nav.querySelector('[data-facet-chips]');
    if (newRow && anchor) anchor.insertAdjacentElement('afterend', newRow);
    if (reopen && facets) {
      var toggle = nav.querySelector('[data-facet-popout-toggle][aria-controls="' + reopen + '"]');
      if (toggle) {
        facets.openPanel(toggle);
        if (facets.keepPanel) facets.keepPanel(document.getElementById(reopen), kept);
      }
    }
  }

  var seq = 0;
  function render(el) {
    var container = el.container;
    var sid = container && container.getAttribute('data-section-id');
    if (!sid) return false;
    var grid = container.querySelector('[data-products-grid]');
    var url = sectionUrlFor(window.location.pathname + window.location.search, sid);
    var mine = ++seq;
    if (grid) grid.classList.add('is-loading');
    cachedFetch(url)
      .then(function (html) {
        if (mine !== seq) return; // a newer apply is in flight
        var doc = new DOMParser().parseFromString(html, 'text/html');
        swapInner(container, doc, '[data-products-grid]');
        swapInner(container, doc, '[data-results-count]');
        swapInner(container, doc, '[data-collection-sidebar]');
        var sidebar = container.querySelector('[data-collection-sidebar]');
        var countHolder = sidebar && sidebar.querySelector('[data-active-filters-count]');
        if (countHolder) {
          var n = parseInt(countHolder.getAttribute('data-active-filters-count'), 10) || 0;
          container.querySelectorAll('[data-active-filters]').forEach(function (b) {
            b.textContent = n;
            b.classList.toggle('hidden', n < 1);
          });
        }
        var nav = container.querySelector('[data-collection-nav]');
        var freshNav = doc.querySelector('[data-collection-nav]');
        if (nav && freshNav) renderToolbar(nav, freshNav);
        // "X varer" sits outside the sticky nav in the chips layout (and
        // twice in the classic one) — update every copy from the first.
        var freshCount = doc.querySelector('.collection__nav__count');
        if (freshCount) {
          container.querySelectorAll('.collection__nav__count').forEach(function (c) {
            c.innerHTML = freshCount.innerHTML;
          });
        }
        applyInStockCounts(container);
      })
      .catch(function (err) { console.log(err); })
      .then(function () {
        if (mine === seq && grid) grid.classList.remove('is-loading');
      });
    return true;
  }

  /* Prefetch on hover intent: chip options carry their URL; drawer values
     derive it from the form. 80 ms of hover separates a sweep from intent. */
  var HOVER_TARGETS = 'a.spejder-facet-popout__option, [data-collection-sidebar] .sidebar__item';
  var hoverTimer = null;
  var hoverItem = null;
  function prefetchFor(target) {
    var el = document.querySelector('collection-filters-form');
    var container = el && el.container;
    var sid = container && container.getAttribute('data-section-id');
    if (!sid) return;
    var option = target.closest('a.spejder-facet-popout__option');
    if (option) {
      var href = option.getAttribute('href') || '';
      if (href.charAt(0) === '/') cachedFetch(sectionUrlFor(inStockUrl(container, href).url, sid));
      return;
    }
    var item = target.closest('[data-collection-sidebar] .sidebar__item');
    var input = item && item.querySelector('input[type="checkbox"]');
    if (input && !input.disabled && el.form) cachedFetch(sectionUrlFor(inStockUrl(container, urlWithToggled(el.form, input)).url, sid));
  }
  document.addEventListener('pointerover', function (e) {
    if (!e.target || !e.target.closest || e.pointerType === 'touch') return;
    var item = e.target.closest(HOVER_TARGETS);
    if (item === hoverItem) return; // still inside the same option
    clearTimeout(hoverTimer);
    hoverItem = item;
    if (!item) return;
    hoverTimer = setTimeout(function () { prefetchFor(item); }, 80);
  }, { passive: true });

  /* Drawer checkboxes apply on the click itself. The theme routes every
     sidebar `input` event through one 500 ms debounce (meant for the price
     fields) — half a second of nothing after a tick. Checkboxes submit
     straight away here; the theme's debounced updatePrice is told to skip
     them so the price fields keep their debounce and nothing submits twice. */
  document.addEventListener('input', function (e) {
    var input = e.target;
    if (!input || input.type !== 'checkbox' || !input.closest || !input.closest('[data-collection-sidebar]')) return;
    var el = input.closest('collection-filters-form');
    if (el && typeof el.submitForm === 'function') el.submitForm(e);
  });

  customElements.whenDefined('collection-filters-form').then(function () {
    var proto = customElements.get('collection-filters-form').prototype;
    var themeUpdatePrice = proto.updatePrice;
    proto.updatePrice = function (event) {
      if (event && event.target && event.target.type === 'checkbox') return;
      return themeUpdatePrice.call(this, event);
    };
    var themeSubmit = proto.submitForm;
    proto.submitForm = function (event, url) {
      url = url || '';
      if (!this.container || !this.container.getAttribute('data-section-id')) {
        return themeSubmit.call(this, event, url);
      }
      // Relewise-driven search results: the grid is filled client-side by
      // relewise-listing.js from the URL at load (in Relewise mode the search
      // page renders no collection-filters-form at all, so this branch only
      // matters for a stale element), and a sort change must be a real
      // navigation — an AJAX swap only brings in the empty shell.
      if (this.container.querySelector('[data-relewise-search-grid]')) {
        if (!(event && event.type === 'popstate')) {
          window.location.assign(url === '' ? urlFromForm(this.form) : url);
        }
        return;
      }
      if (event && event.type === 'popstate') {
        if (this.sort) this.onSortCheck(event);
      } else {
        var next = inStockUrl(this.container, url === '' ? urlFromForm(this.form) : url);
        window.history.pushState({ spejderAutoStock: next.auto }, '', next.url);
      }
      render(this);
    };
    var filtersForm = document.querySelector('collection-filters-form');
    if (filtersForm) applyInStockCounts(filtersForm.container);
  });
})();

/* Flickity ships hardcoded English aria-labels ("Previous"/"Next") on its
   prev/next buttons — the only non-Danish strings in the storefront chrome.
   Sliders init lazily all over the theme, so relabel via observer instead of
   patching the vendor file. Visible UI is untouched (the buttons are icons). */
(function () {
  var LABELS = { Previous: 'Forrige', Next: 'Næste' };
  function relabel(root) {
    var buttons = (root || document).querySelectorAll('.flickity-prev-next-button[aria-label="Previous"], .flickity-prev-next-button[aria-label="Next"]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('aria-label', LABELS[buttons[i].getAttribute('aria-label')]);
    }
  }
  var observer = new MutationObserver(function () { relabel(); });
  function start() {
    relabel();
    observer.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* Product-card sibling swatches: stop the hover flicker.
 *
 * The theme's SiblingSwatches replaces [data-product-price]'s markup on
 * mouseenter with a single-line price. When the card's own price block is
 * taller than that — a member price or a struck sale price is two or three
 * lines — the card shrinks mid-hover, the swatch row moves up out from under
 * the cursor, the holder's mouseleave fires, the original price is restored,
 * the row moves back under the cursor, and it loops: the card flickers and
 * jumps.
 *
 * Pin the price holder's height for as long as the cursor is anywhere in the
 * swatch row, so swapping its contents cannot move anything below it. The
 * height is measured rather than hardcoded, so it stays correct for every card
 * state (member price, sale, plain) without tracking the Figma line heights.
 *
 * Bound on the ROW, not the individual swatches: entering the row happens
 * before entering any swatch inside it, so the measurement is always taken
 * while the card is still in its resting state. The theme reserves space for
 * the cutline the same way, with a non-breaking space.
 */
(function () {
  var ROW = '[data-sibling-inner]';
  var PRICE = '[data-product-price]';
  var CARD = '[data-grid-item]';

  function pin(row) {
    var card = row.closest(CARD);
    var price = card && card.querySelector(PRICE);
    if (!price || price.style.minHeight) return;
    var h = price.offsetHeight;
    if (h > 0) price.style.minHeight = h + 'px';
  }

  function unpin(row) {
    var card = row.closest(CARD);
    var price = card && card.querySelector(PRICE);
    if (!price) return;
    // After the theme's own mouseleave handler has put the original price
    // back, so the card never renders un-pinned at the collapsed height.
    window.setTimeout(function () {
      price.style.minHeight = '';
    }, 0);
  }

  function bind(root) {
    var rows = (root || document).querySelectorAll(ROW);
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (row.__swatchHeightPinned) continue;
      row.__swatchHeightPinned = true;
      row.addEventListener('mouseenter', function () { pin(this); });
      row.addEventListener('mouseleave', function () { unpin(this); });
    }
  }

  var observer = new MutationObserver(function () { bind(); });
  function start() {
    bind();
    observer.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* Search popdown — keep results open after the iOS keyboard "Done" key
   (Emil 2026-08-25). theme.js's <predictive-search> closes its results on
   any focusout that leaves the popdown (onFocusOut -> close()): correct on
   desktop, but on iPhone the keyboard's Done/checkmark key blurs the input
   to <body> without submitting, so the results went invisible and lost
   their --results-height while the popdown stayed open — leaving a blank
   panel whose touches fell through to the page ("background scrolls, not
   the results"). If the popdown is still open and there is a query with
   results, re-open them; open() also recomputes --results-height from the
   now keyboard-free visualViewport, so the list scrolls again. */
(function () {
  document.addEventListener('focusout', function (e) {
    var input = e.target && e.target.closest ? e.target.closest('input[data-predictive-search-input]') : null;
    if (!input) return;
    var ps = input.closest('predictive-search');
    var popdown = input.closest('header-search-popdown');
    if (!ps || !popdown || typeof ps.open !== 'function') return;
    // theme.js decides in a setTimeout(0); run after it.
    setTimeout(function () {
      if (!popdown.classList.contains('is-open')) return;
      if (popdown.contains(document.activeElement) && document.activeElement !== document.body) return;
      if (!input.value.trim() || !ps.hasAttribute('results')) return;
      if (!ps.hasAttribute('open')) ps.open();
    }, 60);
  }, true);
})();

/* PLP → PDP breadcrumb + filter memory (Magnus 2026-09-10) — the
   COLLECTION half. The PDP half (rebuilding the trail from this snapshot,
   pinning it to history.state) is an INLINE script in
   snippets/breadcrumbs.liquid so it runs while the nav is parsed, before
   first paint — done here in deferred JS it painted the canonical trail
   first and then visibly swapped it (Magnus, 2026-09-10). Read that snippet
   for the full contract; in short:

   Server-side the PDP trail is the CANONICAL catalog hierarchy (Emil
   2026-08-12, Christian 2026-08-23). A shopper who opens a product FROM a
   collection page instead gets that collection page's OWN breadcrumb (its
   hierarchy up to itself) — Forside › Mænd › shirt — with the PLP's filter
   query on the last crumb, because both listing engines (Relewise `f.*`/
   price/sort_by and the legacy Shopify `filter.*`) keep the full filter
   state in the URL.

   This block: collection pages snapshot path + query + trail into
   sessionStorage (at load and on pagehide, so the last in-place pushState
   wins); every template that is neither a collection nor a PDP clears it so
   a later menu visit starts clean. PDPs leave it alone (the inline script
   decides, and a PDP reached from elsewhere clears it there). */
(function () {
  var KEY = 'spejder:plp-state';
  var cls = document.body.classList;
  if (cls.contains('template-product')) return;
  if (!cls.contains('template-collection')) {
    try { sessionStorage.removeItem(KEY); } catch (e) {}
    return;
  }
  var snapshot = function () {
    /* The PLP's crumbs after Home: ancestor links + the current span (the
       collection, or the active Produkt-type label on the legacy listing). */
    var trail = [];
    var nav = document.querySelector('.breadcrumbs');
    if (nav) {
      Array.prototype.forEach.call(nav.children, function (el, i) {
        if (i === 0 || el.classList.contains('breadcrumbs__arrow')) return;
        trail.push({ label: el.textContent.trim(), href: el.tagName === 'A' ? el.getAttribute('href') : null });
      });
    }
    try {
      sessionStorage.setItem(KEY, JSON.stringify({ path: location.pathname, search: location.search, trail: trail }));
    } catch (e) {}
  };
  snapshot();
  window.addEventListener('pagehide', snapshot);
})();

/* Blog category → article breadcrumb (Emil 2026-09-28) — the CATEGORY half of
   the article's entry-category trail; the article half is the inline script
   after the nav in snippets/breadcrumbs.liquid (read it for the contract).
   Blog category pages (a tag view: the nav carries data-blog-tags) snapshot
   their own trail + tags into sessionStorage; articles leave it alone so
   clicking from article to article keeps it; every other page clears it. */
(function () {
  var KEY = 'spejder:blog-state';
  var cls = document.body.classList;
  if (cls.contains('template-article')) return;
  var nav = cls.contains('template-blog') ? document.querySelector('.breadcrumbs[data-blog-tags]') : null;
  if (!nav) {
    try { sessionStorage.removeItem(KEY); } catch (e) {}
    return;
  }
  var tags = nav.getAttribute('data-blog-tags').split(',').filter(Boolean);
  var snapshot = function () {
    var trail = [];
    Array.prototype.forEach.call(nav.children, function (el, i) {
      if (i === 0 || el.classList.contains('breadcrumbs__arrow')) return;
      trail.push({ label: el.textContent.trim(), href: el.tagName === 'A' ? el.getAttribute('href') : null });
    });
    try {
      sessionStorage.setItem(KEY, JSON.stringify({ path: location.pathname, search: location.search, trail: trail, tags: tags }));
    } catch (e) {}
  };
  snapshot();
  window.addEventListener('pagehide', snapshot);
})();
